import {
  useState,
  useEffect,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from "react";
import "../../css/Panel.css";
import "../../css/Patient.css";
import "../../css/PatientSearch.css";
import "../../css/custom-datatable.css";
import "../css/Sales.css";
import "../css/PopupMessage.css";

import NavTableCell from "../components/NavTableCell";
import SaleTableItemPago from "../components/SaleTableItemPago";
import SaleTableItemIVA from "../components/SaleTableItemIVA";
import PopupTitle from "../components/PopupTitle";
import InputDataCurrency from "../components/InputDataCurrency";
import RoundedUserPic from "../components/RoundedUserPic";
import { transformPatientPicture } from "../utils/patients";
import CartItem from "../components/CartItem";
import PopupPin from "../components/PopupPin";
import PopupSectionTitle from "../components/PopupSectionTitle";
import PopupPaymentPointsItem from "../components/PopupPaymentPointsItem";
import PopupDescriptionItem from "../components/PopupDescriptionItem";
import PopupCrossSellingLineItem from "../components/PopupCrossSellingLineItem";
import PopupTitleDescriptionItem from "../components/PopupTitleDescriptionItem";
import HealthData from "../components/HealthData";
import PopupVerticalSpacer from "../components/PopupVerticalSpacer";

import CheckBox from "../../components/CheckBox";
import RadioButton from "../../components/RadioButton";
import ButtonIconH from "../../components/ButtonIconH";
import InputData from "../../components/InputData";
import InputSearch from "../../components/InputSearch";
import Dropdown from "../../components/Dropdown";
import DropdownKey from "../../components/DropdownKey";
import DropdownFilter from "../../components/DropdownFilter";
import PopupNIFTypes from "../../components/PopupNIFTypes";
import PopupCP from "../components/PopupCP";
import PopupSaleObservations from "../components/PopupSaleObservations";
import PopupPrintingSale from "../components/PopupPrintingSale";
import PopupEmail from "../components/PopupEmail";
import PopupInvoicePrinting, {
  INVOICE_TYPE_TO_TIPO_FACTURA,
  isTicketServiceOpen,
  printInvoice,
  printInvoiceDirect,
} from "../components/PopupInvoicePrinting";
import ButtonIconV from "../../components/ButtonIconV";
import TooltipBox from "../../components/Tooltip";
import LoadingScreen from "../../components/LoadingScreen";

import { post as rpost } from "../js/api";
import { post as spost } from "../../support/utils/api";
import { post } from "../../js/post";
import {
  formatCurrency,
  formatNumber,
  createAddress,
  calculatePVU,
  calculateDto,
  calculateIVASuperRed,
  getFamilyFromOPTIWINCode,
  calculateDtoFromAll,
} from "../utils/utils";
import { calculateDtos } from "../../js/calculateDtos";
import { exportToFile } from "../js/exportToFile";
import { newSale, newSaleLine, newCrossSelling } from "../skels/Sale";
import {
  calculatePointsValue,
  calculatePointsFromValue,
  calculatePointsGenerated,
} from "../utils/sales";

import { userData, selectedOptic, provinceOptions } from "../../js/utils";

import DataTable from "react-data-table-component";
import moment from "moment";
import { EMPTY_LOYALTY_CONFIG } from "../js/constants";
import { validateNIF } from "../js/nif";
import { useDocumentTypes } from "../../hooks/useDocumentTypes";

const MAX_IMPORTE_FACTURA = 3000;
const MAX_IMPORTE_EFECTIVO = 1000;
const NUM_PRODUCTS_LIMIT = 20;
const HEALTH_CONTROL_FAMILIES = [1, 2, 3];
const EMPTY_EXEMPTION_OPTION = { value: "", text: "" };

// El motivo de exención solo aplica a líneas con IVA 0.
const isExemptionEnabled = (iva) => parseFloat(iva) === 0;

export default forwardRef(
  (
    {
      show,
      onClickMenuOption,
      createPopupQuestion,
      removePopupQuestion,
      onGoBack,
      saleId,
      orderCards = [],
      orderPatientId = -1,
      createdSale = null,
    },
    ref,
  ) => {
    const [loaded, setLoaded] = useState(false);
    const [emptySale, setEmptySale] = useState(false);
    const [venta, setVenta] = useState(null);
    const [ventaLinesTable, setVentaLinesTable] = useState([]);
    const [showFactData, setShowFactData] = useState(false);
    const [nId, setNId] = useState(-1);
    const [forceCreateNewRow, setForceCreateNewRow] = useState(false);
    const [facturaCompleta, setFacturaCompleta] = useState(false);
    const [rectificationType, setRectificationType] = useState("simple");
    const [rectificationReason, setRectificationReason] = useState("");
    const [totalDtoF, setTotalDtoF] = useState("");
    const [totalBaseF, setTotalBaseF] = useState("");
    const [totalIVAF, setTotalIVAF] = useState("");
    const [totalF, setTotalF] = useState("");
    const [totalPaidF, setTotalPaidF] = useState("");
    const [totalRemainingF, setTotalRemainingF] = useState("");
    const [invoice, setInvoice] = useState(null);
    //const [paymentMethodsOr, setPaymentMethodsOr] = useState(null);
    const [paymentMethods, setPaymentMethods] = useState(null);
    // Formas de pago del popup "Realizar pago" (filtradas por importe al abrirlo)
    const [paymentPopupMethods, setPaymentPopupMethods] = useState([]);
    const [cardTypes, setCardTypes] = useState(null);
    const [cashVouchers, setCashVouchers] = useState([]);
    const [payment, setPayment] = useState(null);
    const [savingPayment, setSavingPayment] = useState(false);
    const [editPayment, setEditPayment] = useState(null);
    const [editPaymentDeliveredKey, setEditPaymentDeliveredKey] = useState(0);
    const [address, setAddress] = useState(null);
    // Id del input de CP mal formado ("" si no hay error)
    const [errorCP, setErrorCP] = useState("");

    useEffect(() => {
      if (errorCP !== "") {
        createPopupQuestion(
          "Por favor, revise el código postal.",
          () => {
            const el = document.getElementById(errorCP);
            if (el) {
              el.focus();
            }
            setErrorCP("");
            removePopupQuestion();
            return;
          },
          null,
          "Entendido",
        );
      }
    }, [errorCP]);
    const [cartPopup, setCartPopup] = useState(null);
    const [nifTypePopup, setNifTypePopup] = useState(false);
    const [nifTypePopupTarget, setNifTypePopupTarget] = useState("venta");
    const [documentTypesList] = useDocumentTypes();
    const [pinPopup, setPinPopup] = useState(false);
    const [pinPopupAgentName, setPinPopupAgentName] = useState("");
    const [pinPopupAgentid, setPinPopupAgentId] = useState(-1);
    const [pinPopupOnAccept, setPinPopupOnAccept] = useState(null);
    const [pinPopupOnCancel, setPinPopupOnCancel] = useState(null);
    const [showPopupCP, setShowPopupCP] = useState(false);
    const [showObservationsPopup, setShowObservationsPopup] = useState(false);
    const [showPrintingSalePopup, setShowPrintingSalePopup] = useState(false);
    const [showEmailPopup, setShowEmailPopup] = useState(false);
    const [emailAttachments, setEmailAttachments] = useState([]);
    const [emailDestinatario, setEmailDestinatario] = useState("");
    const [emailAsunto, setEmailAsunto] = useState("");
    const [paymentEmailIdVenta, setPaymentEmailIdVenta] = useState(null);
    const [showInvoicePrintingPopup, setShowInvoicePrintingPopup] =
      useState(false);
    const [invoicePrintingType, setInvoicePrintingType] = useState("");
    const [cpPopupAddress, setCPPopupAddress] = useState("");
    const [cpPopupCity, setCPPopupCity] = useState("");
    const [cpPopupType, setCPPopupType] = useState("personal");
    const [tiposIVA, setTiposIVA] = useState(null);
    const [exemptionOptions, setExemptionOptions] = useState([
      EMPTY_EXEMPTION_OPTION,
    ]);
    const [IVASuperRed, setIVASuperRed] = useState(4);
    const [crossSellingPopup, setCrossSellingPopup] = useState(null);
    const [tiposCrossSelling, setTiposCrossSelling] = useState(null);
    const [motivosAnulacion, setMotivosAnulacion] = useState(null);
    const [paidOr, setPaidOr] = useState(false);

    const [agents, setAgents] = useState(null);
    const agentsSoldBy = useMemo(
      () => (agents ? agents.filter((agent) => agent.id !== -1) : agents),
      [agents],
    );
    const [filterRealizadoPor, setFilterRealizadoPor] = useState({
      id: -1,
      text: "",
    });
    const [filterEntregadoPor, setFilterEntregadoPor] = useState({
      id: -1,
      text: "",
    });
    const [filterCrossSellingAgente, setFilterCrossSellingAgent] = useState({
      id: -1,
      text: "",
    });

    const [campaigns, setCampaigns] = useState(null);
    const [filterCampaign, setFilterCampaign] = useState({
      id: -1,
      text: "",
    });

    const [filterDescription, setFilterDescription] = useState({
      id: -1,
      text: "",
    });

    const [showHealthControlPopup, setShowHealthControlPopup] = useState(false);
    const [healthControlPopupItems, setHeathControlPopupItems] = useState([]);

    const [cancellationPopup, setCancellationPopup] = useState(null);

    const [generatingInvoice, setGeneratingInvoice] = useState(false);

    const [rectifyingInvoiceId, setRectifyingInvoiceId] = useState(-1);
    const [rectifyingInvoiceTotalPaid, setRectifyingInvoiceTotalPaid] =
      useState(0);
    const [rectifyingInvoicePositive, setRectifyingInvoicePositive] =
      useState(true);

    const [loading, setLoading] = useState(true);

    const [loyaltyId, setLoyaltyId] = useState("");
    const [loyaltyPoints, setLoyaltyPoints] = useState("");
    const [loyaltyPointsValue, setLoyaltyPointsValue] = useState("");
    const [loyaltyPointsApplied, setLoyaltyPointsApplied] = useState(0);
    const [loyaltyPointsAppliedValue, setLoyaltyPointsAppliedValue] =
      useState(0);
    const [loyaltyPointsGenerated, setLoyaltyPointsGenerated] = useState(0);
    const [loyaltyPointsGeneratedValue, setLoyaltyPointsGeneratedValue] =
      useState(0);
    const [loyaltyConfig, setLoyaltyConfig] = useState(EMPTY_LOYALTY_CONFIG);
    const [opticConfig, setOpticConfig] = useState({
      idFidelizacion: "",
      confTicketDobleCopiaVenta: false,
      controlSanitario: false,
      conexionTicket: "",
      ticketServiceOpen: false,
      formatoTicketPorDefecto: "",
      // Opciones del campo "Descripción" de la cabecera.
      descriptionOptions: [{ id: -1, text: "" }],
    });

    useImperativeHandle(ref, () => ({
      canChangeScreen: (screen, params) => {
        const canChange =
          (saleId !== -1 && rectifyingInvoiceId === -1) ||
          (saleId === -1 &&
            JSON.stringify(venta) === JSON.stringify(emptySale));
        if (!canChange) {
          onGoToScreen(screen, true);
        }
        return canChange;
      },
    }));

    const printDocumentOptions = useMemo(
      () =>
        [
          { id: "imp-ticket", text: "Factura simple (Ticket)" },
          {
            id: "imp-factura-canje",
            text: "Factura canje (A4)",
          },
          {
            id: "imp-ticket-abono",
            text: "Factura abono (Ticket)",
          },
          {
            id: "imp-ticket-rect",
            text: "Factura rectificativa simple (Ticket)",
          },
          { id: "imp-factura", text: "Factura completa (A4)" },
          {
            id: "imp-factura-abono",
            text: "Factura abono (A4)",
          },
          {
            id: "imp-factura-rect",
            text: "Factura rectificativa completa (A4)",
          },
        ].filter((item) => {
          return (
            venta &&
            venta.id !== -1 &&
            rectifyingInvoiceId === -1 &&
            ((item.id === "imp-ticket" &&
              (venta.tipoFactura === "Simple" ||
                (venta.tipoFactura === "Completa" &&
                  (venta.numeroFacturaRectificada ?? "").startsWith("S")) ||
                (venta.tipoFactura === "FacturaDeCanje" &&
                  (venta.serieFactura ?? "").startsWith("S")))) ||
              (item.id === "imp-factura-canje" &&
                venta.tipoFactura === "FacturaDeCanje") ||
              (item.id === "imp-ticket-abono" &&
                venta.status === "Anulada" &&
                venta.tipoFactura === "Simple") ||
              (item.id === "imp-ticket-rect" &&
                venta.status === "Rectificativa" &&
                (venta.tipoFactura === "Simple" ||
                  venta.tipoFactura === "FacturaDeCanje")) ||
              (item.id === "imp-factura" &&
                venta.tipoFactura === "Completa" &&
                !(venta.numeroFacturaRectificada ?? "").startsWith("S")) ||
              (item.id === "imp-factura-abono" &&
                venta.status === "Anulada" &&
                (venta.tipoFactura === "Completa" ||
                  venta.tipoFactura === "FacturaDeCanje")) ||
              (item.id === "imp-factura-rect" &&
                venta.status === "Rectificativa" &&
                venta.tipoFactura === "Completa"))
          );
        }),
      [venta, rectifyingInvoiceId],
    );

    const ventaColumns = useMemo(
      () => [
        {
          name: "Código",
          width: "9%",
          cell: (row) =>
            row.type === "user-line" ? (
              <div className="sales-table-cart-user">
                <RoundedUserPic
                  width={25}
                  height={25}
                  img={transformPatientPicture(row.pic)}
                />
                <span>{row.patient}</span>
                {saleId === -1 && (
                  <img
                    className="sales-table-cart-remove"
                    src="/images/remove-blue.svg"
                    onClick={() => onRemoveCart(row.cartId)}
                  />
                )}
              </div>
            ) : (
              <NavTableCell
                id={"ntc-" + (row.index + 1) + "-1"}
                value={row.code}
                type=""
                canBeEmpty={true}
                onChange={(value) => {
                  const ventaN = structuredClone(venta);
                  ventaN.lines[row.index].code = value;
                  setVenta(ventaN);
                  const ventaLinesTableN = structuredClone(ventaLinesTable);
                  ventaLinesTableN[row.index].code = value;
                  setVentaLinesTable(ventaLinesTableN);
                }}
                onBlur={() => {
                  let ventaN = structuredClone(venta);
                  ventaN = updateVentasTotal(ventaN);
                  setVenta(ventaN);
                }}
                onNoNextCell={createNewRow}
                onPressEnter={async (value) => {
                  const sourceEl = document.activeElement;
                  const found = await readProduct(value, row.index);
                  if (found && document.activeElement === sourceEl) {
                    setTimeout(() => {
                      const el = document.getElementById(
                        "ntc-" + (row.index + 1) + "-2",
                      );
                      if (el) {
                        el.focus();
                        setTimeout(() => {
                          if (document.activeElement === el) {
                            el.select();
                          }
                        }, 1);
                      }
                    }, 100);
                  }
                }}
                readOnly={
                  rectifyingInvoiceId === -1 &&
                  (saleId !== -1 || row.cardId != -1)
                }
                stock={saleId !== -1 ? "" : row.stock}
              />
            ),
        },
        {
          name: "Descripción del producto",
          width: "33%",
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-2"}
                  value={row.description}
                  type=""
                  canBeEmpty={true}
                  onChange={(value) => {
                    const ventaN = structuredClone(venta);
                    getLineRef(ventaN, row).description = value;
                    setVenta(ventaN);
                    const ventaLinesTableN = structuredClone(ventaLinesTable);
                    ventaLinesTableN[row.index].description = value;
                    setVentaLinesTable(ventaLinesTableN);
                  }}
                  onBlur={() => {
                    let ventaN = structuredClone(venta);
                    ventaN = updateVentasTotal(ventaN);
                    setVenta(ventaN);
                  }}
                  onNoNextCell={createNewRow}
                  showList={true}
                  updateList={getProducts}
                  onSelectOption={(product) =>
                    selectProduct(product, row.index)
                  }
                  readOnly={rectifyingInvoiceId === -1 && saleId !== -1}
                  stock={saleId !== -1 ? "" : row.stock}
                />
              )}
            </div>
          ),
        },
        {
          name: "PVP",
          width: "8%",
          headerStyle: { textAlign: "center" },
          center: true,
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-3"}
                  value={row.pvp}
                  type="type-currency"
                  justify="center"
                  onChange={(value) => {}}
                  onNoNextCell={createNewRow}
                  onBlur={(value) => {
                    if (value != getLineRef(venta, row).pvp) {
                      onChangePVPLine(
                        typeof value === "string"
                          ? value.replace(",", ".")
                          : value,
                        row,
                      );
                    }
                  }}
                  readOnly={rectifyingInvoiceId === -1 && saleId !== -1}
                  stock={saleId !== -1 ? "" : row.stock}
                />
              )}
            </div>
          ),
        },
        {
          name: "Dto.",
          width: "8%",
          center: true,
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-4"}
                  value={Math.round(parseFloat(row.dto) || 0)}
                  type="type-int-perc"
                  justify="center"
                  onChange={(value) => {}}
                  onNoNextCell={createNewRow}
                  onBlur={(value) => {
                    // El dto de la línea es float, pero la celda muestra el
                    // entero: solo se recalcula si cambia el valor visible.
                    if (
                      value !=
                      Math.round(parseFloat(getLineRef(venta, row).dto) || 0)
                    ) {
                      setTimeout(() => onChangeDtoLine(value, row), 100);
                    }
                  }}
                  readOnly={rectifyingInvoiceId === -1 && saleId !== -1}
                  stock={saleId !== -1 ? "" : row.stock}
                />
              )}
            </div>
          ),
        },
        {
          name: "IVA",
          width: "8%",
          center: true,
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-5"}
                  value={row.iva}
                  type="type-float-perc"
                  justify="center"
                  onChange={(value) => {}}
                  onNoNextCell={createNewRow}
                  onBlur={(value) => {
                    if (value != getLineRef(venta, row).iva) {
                      setTimeout(
                        () =>
                          onChangeIVALine(
                            typeof value === "string"
                              ? value.replace(",", ".")
                              : value,
                            row,
                          ),
                        100,
                      );
                    }
                  }}
                  readOnly={rectifyingInvoiceId === -1 && saleId !== -1}
                  stock={saleId !== -1 ? "" : row.stock}
                />
              )}
            </div>
          ),
        },
        {
          name: "PVU",
          width: "8%",
          center: true,
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-6"}
                  value={row.pvu}
                  type="type-currency"
                  justify="center"
                  onChange={(value) => {}}
                  onNoNextCell={createNewRow}
                  onBlur={(value) => {
                    if (value != getLineRef(venta, row).pvu) {
                      onChangePVULine(
                        typeof value === "string"
                          ? value.replace(",", ".")
                          : value,
                        row,
                      );
                    }
                  }}
                  readOnly={rectifyingInvoiceId === -1 && saleId !== -1}
                  stock={saleId !== -1 ? "" : row.stock}
                />
              )}
            </div>
          ),
        },
        {
          name: "Uds.",
          width: "8%",
          center: true,
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-7"}
                  value={row.uds}
                  type="type-only-numbers"
                  justify="center"
                  onChange={(value) => {}}
                  onNoNextCell={createNewRow}
                  onBlur={(value) => {
                    if (value != getLineRef(venta, row).uds) {
                      onChangeUdsLine(value, row);
                    }
                  }}
                  readOnly={rectifyingInvoiceId === -1 && saleId !== -1}
                  stock={saleId !== -1 ? "" : row.stock}
                />
              )}
            </div>
          ),
        },
        {
          name: "Total",
          width: saleId === -1 || rectifyingInvoiceId !== -1 ? "8%" : "11%",
          center: true,
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" && (
                <NavTableCell
                  id={"ntc-" + (row.index + 1) + "-8"}
                  value={row.total}
                  type="type-currency"
                  justify="center"
                  onChange={(value) => {}}
                  onNoNextCell={createNewRow}
                  onBlur={(value) => {
                    if (value != getLineRef(venta, row).total) {
                      onChangeTotalLine(
                        typeof value === "string"
                          ? value.replace(",", ".")
                          : value,
                        row,
                      );
                    }
                  }}
                  readOnly={rectifyingInvoiceId === -1 && saleId !== -1}
                  stock={saleId !== -1 ? "" : row.stock}
                />
              )}
            </div>
          ),
        },
        {
          name: "M. Exención",
          width: "7%",
          center: true,
          cell: (row) => (
            <div
              className={
                row.type === "user-line" ? "ntc-hide" : "ntc-cell-header"
              }
            >
              {row.type !== "user-line" &&
                rectifyingInvoiceId === -1 &&
                saleId !== -1 && (
                  // Venta cerrada: se muestra el código recibido tal cual,
                  // con la descripción en el tooltip.
                  <>
                    <NavTableCell
                      id={"ntc-" + (row.index + 1) + "-9"}
                      value={row.exemption ?? ""}
                      type="type-alpha"
                      justify="center"
                      onChange={(value) => {}}
                      readOnly={true}
                      stock=""
                    />
                    {row.exemptionDescription !== "" && (
                      <TooltipBox
                        id={"tts-ntc-" + (row.index + 1) + "-9"}
                        content={
                          <div className="sale-exemption-tooltip">
                            {row.exemption} - {row.exemptionDescription}
                          </div>
                        }
                      />
                    )}
                  </>
                )}
              {row.type !== "user-line" &&
                (saleId === -1 || rectifyingInvoiceId !== -1) && (
                  <div
                    className={
                      "ntc-exemption" +
                      (saleId === -1 && row.stock !== "" && row.stock <= 0
                        ? " no-stock"
                        : "")
                    }
                  >
                    <DropdownKey
                      format="table-cell"
                      includeKeyInOption={true}
                      tooltip={true}
                      optionList={exemptionOptions}
                      op={row.exemption ?? null}
                      onChange={(item) => {
                        const ventaN = structuredClone(venta);
                        const line = getLineRef(ventaN, row);
                        line.exencionCodigo = item?.value ?? "";
                        line.exencionDescripcion = item?.descripcion ?? "";
                        setVenta(ventaN);
                        const ventaLinesTableN =
                          structuredClone(ventaLinesTable);
                        ventaLinesTableN[row.index].exemption =
                          line.exencionCodigo;
                        setVentaLinesTable(ventaLinesTableN);
                      }}
                      disabled={!isExemptionEnabled(row.iva)}
                    />
                  </div>
                )}
            </div>
          ),
        },
        {
          name: "",
          width: saleId === -1 || rectifyingInvoiceId !== -1 ? "3%" : "0%",
          cell: (row) => (
            <div
              className={
                row.type === "user-line"
                  ? "ntc-hide"
                  : "ntc-cell-header" +
                    (saleId === -1 && row.stock !== "" && row.stock <= 0
                      ? " ntc-cell-header-no-stock"
                      : "")
              }
            >
              {row.type !== "user-line" &&
                row.cardId == -1 &&
                (saleId === -1 || rectifyingInvoiceId !== -1) && (
                  <div className="navtable-opt ntc-trash ">
                    <img
                      src="/images/remove-blue.svg"
                      onClick={() => removeLine(row.index)}
                    />
                  </div>
                )}
            </div>
          ),
        },
      ],
      [venta, exemptionOptions],
    );

    const conditionalRowStyles = [
      {
        when: (row) => row.type === "user-line",
        style: {
          width: "100%",
        },
      },
      {
        when: (row) => row.type === "sale-line" && row.index === 0,
        style: {
          width: "9%",
        },
      },
    ];

    const createVentaLinesTable = (v) => {
      let index = 0;
      const lines = [];

      v.lines.forEach((line) => {
        const row = {
          index,
          type: "sale-line",
          id: line.id,
          code: line.code,
          description: line.description,
          pvp: line.pvp,
          dto: line.dto,
          iva: line.iva,
          pvu: line.pvu,
          uds: line.uds,
          total: line.total,
          exemption: isExemptionEnabled(line.iva) ? line.exencionCodigo : "",
          exemptionDescription: line.exencionDescripcion ?? "",
          cardId: -1,
          stock: line.stock,
        };
        lines.push(row);
        index++;
      });

      v.carts.forEach((cart, cartIndex) => {
        const cartRow = {
          type: "user-line",
          cartId: cart.id,
          patient: cart.patientCode + " - " + cart.patientNameLastName,
          pic: cart.patientPic,
        };
        lines.push(cartRow);
        index++;
        cart.lines.forEach((line, lineIndex) => {
          const row = {
            index,
            type: "sale-line",
            id: line.id,
            code: line.code,
            description: line.description,
            pvp: line.pvp,
            dto: line.dto,
            iva: line.iva,
            pvu: line.pvu,
            uds: line.uds,
            total: line.total,
            exemption: isExemptionEnabled(line.iva) ? line.exencionCodigo : "",
            exemptionDescription: line.exencionDescripcion ?? "",
            cardId: cart.id,
            cartIndex,
            lineIndex,
            stock: line.stock,
          };
          lines.push(row);
          index++;
        });
      });

      return lines;
    };

    const getLineRef = (ventaN, row) =>
      row.cardId === -1
        ? ventaN.lines[row.index]
        : ventaN.carts[row.cartIndex].lines[row.lineIndex];

    const loadPaymentMethods = async () => {
      const response = await post("ListarFormasPago.php", {
        token: userData.token,
        optica: selectedOptic.id,
      });
      const fPago = response.map((item) => {
        return {
          id: item.id,
          text: item.descripcion,
        };
      });
      setPaymentMethods(fPago);
    };

    const loadCardTypes = async () => {
      const response = await post("ListarTiposTarjeta.php", {
        token: userData.token,
        optica: selectedOptic.id,
      });
      const tTarjeta = response.map((item) => {
        return {
          id: item.id,
          text: item.descripcion,
        };
      });
      tTarjeta.unshift({
        id: "",
        text: "",
      });
      setCardTypes(tTarjeta);
    };

    const loadAgents = async () => {
      const response = await rpost("fichas/ListarAgentes.php", {
        token: userData.token,
        optica: selectedOptic.id,
      });
      let agentsN = response.map((item) => {
        return {
          id: item.id,
          text: item.nombreApellidos,
        };
      });
      agentsN.unshift({
        id: -1,
        text: "",
      });
      setAgents(agentsN);
    };

    const loadCampaigns = async () => {
      const response = await post("ListarCampanas.php", {
        token: userData.token,
        idOptica: selectedOptic.id,
        incluirCampanasCRM: true,
        incluirCampanasCRMSoloActivas: true,
      });

      let campaignsN = response.map((item, index) => {
        return {
          id: index,
          text: item,
        };
      });
      campaignsN.unshift({
        id: -1,
        text: "",
      });
      setCampaigns(campaignsN);
    };

    const loadTiposIVA = async () => {
      const response = await post("ListarTiposIVA.php", {
        token: userData.token,
        idOptica: selectedOptic.id,
      });
      setTiposIVA(response.tiposIVA);
      setIVASuperRed(response.superReducido);
    };

    const loadExencionesIVA = async () => {
      const response = await post("ListarExencionesIVA.php", {
        token: userData.token,
        idOptica: selectedOptic.id,
      });
      const exemptionOptionsN = (Array.isArray(response) ? response : []).map(
        (item) => ({
          value: item.codigo,
          text: (item.descripcion ?? "").toUpperCase(),
          descripcion: item.descripcion ?? "",
        }),
      );
      exemptionOptionsN.unshift(EMPTY_EXEMPTION_OPTION);
      setExemptionOptions(exemptionOptionsN);
    };

    const loadTiposCrossSelling = async () => {
      const response = await post("ListarTiposCrossSelling.php", {
        token: userData.token,
      });
      const tiposCrossSellingN = response.map((item) => {
        return {
          id: item,
          text: item,
        };
      });
      tiposCrossSellingN.unshift({
        id: -1,
        text: "",
      });
      setTiposCrossSelling(tiposCrossSellingN);
    };

    const loadMotivosAnulacion = async () => {
      const response = await post("ListarMotivosAnulacion.php", {
        token: userData.token,
      });
      const motivosAnulacionN = response.map((item) => {
        return {
          id: item,
          text: item,
        };
      });
      motivosAnulacionN.unshift({
        id: -1,
        text: "",
      });
      setMotivosAnulacion(motivosAnulacionN);
    };

    const loadLoyaltyConfig = async () => {
      const response = await post(
        "ObtenerConfiguracionFidelizacionOptica.php",
        {
          token: userData.token,
          optica: selectedOptic.id,
        },
      );
      const loyaltyConfigN = response.id
        ? {
            id: response.id,
            contravalor: response.contravalor,
            tipoAsignacion: response.tipoAsignacion,
            porCadaXEurosCompra: response.porCadaXEurosCompra,
            ptosGeneradosPorXEurosCompra: response.ptosGeneradosPorXEurosCompra,
            porCadaXEurosAudifonos: response.porCadaXEurosAudifonos,
            ptosGeneradosXEurosAudifonos: response.ptosGeneradosXEurosAudifonos,
            porCadaXEurosCristales: response.porCadaXEurosCristales,
            ptosGeneradosXEurosCristales: response.ptosGeneradosXEurosCristales,
            porCadaXEurosLentillas: response.porCadaXEurosLentillas,
            ptosGeneradosXEurosLentillas: response.ptosGeneradosXEurosLentillas,
            porCadaXEurosLiquidos: response.porCadaXEurosLiquidos,
            ptosGeneradosXEurosLiquidos: response.ptosGeneradosXEurosLiquidos,
            porCadaXEurosMonturas: response.porCadaXEurosMonturas,
            ptosGeneradosXEurosMonturas: response.ptosGeneradosXEurosMonturas,
            porCadaXEurosVarios: response.porCadaXEurosVarios,
            ptosGeneradosXEurosVarios: response.ptosGeneradosXEurosVarios,
            porCadaXEurosSol: response.porCadaXEurosSol,
            ptosGeneradosXEurosSol: response.ptosGeneradosXEurosSol,
          }
        : EMPTY_LOYALTY_CONFIG;
      setLoyaltyConfig(loyaltyConfigN);
    };

    const loadOpticConfig = async () => {
      const response = await rpost(
        "ventas/ObtenerConfiguracionOpticaVenta.php",
        {
          token: userData.token,
          idOptica: selectedOptic.id,
        },
      );
      const opticConfigN = {
        idFidelizacion: response.idFidelizacion ?? "",
        confTicketDobleCopiaVenta: response.confTicketDobleCopiaVenta,
        controlSanitario: response.controlSanitario,
        conexionTicket: response.conexionTicket ?? "",
        ticketServiceOpen: await isTicketServiceOpen(response.conexionTicket),
        formatoTicketPorDefecto: response.formatoTicketPorDefecto ?? "",
        descriptionOptions: [
          { id: -1, text: "" },
          ...(response.descripcionesVentas ?? []).map((item) => ({
            id: item.id,
            text: item.descripcion.toUpperCase(),
          })),
        ],
      };
      setOpticConfig(opticConfigN);
      return opticConfigN;
    };

    const getProducts = async (text) => {
      let result = [];
      if (text.length >= 3) {
        const response = await post("BuscarProductos.php", {
          token: userData.token,
          texto: text,
          total: NUM_PRODUCTS_LIMIT,
        });
        result = response.map((item) => {
          const name = item.marca + " " + item.nombre;
          return {
            id: name,
            text: name,
            element: item,
          };
        });
      }
      return result;
    };

    const readProduct = async (code, index) => {
      if (code.trim() === "") {
        return true;
      }

      const response = await post("ObtenerProducto.php", {
        token: userData.token,
        codigo: code,
        idOptica: selectedOptic.id,
      });

      if (response.codigoOPTIWIN) {
        /* const pos = venta.lines.findIndex((item) => {
          return item.code === response.codigoOPTIWIN;
        });

        if (pos >= 0) {
          if (pos === index) {
            // Found in table, same line
            let ventaN = structuredClone(venta);

            ventaN.lines[index].uds++;

            const res = calculateDtoFromAll(
              ventaN.lines[pos].pvp,
              venta.patientDto,
              ventaN.lines[pos].pvpOffer,
              ventaN.lines[pos].offerFrom,
              ventaN.lines[pos].offerTo,
              ventaN.lines[pos].pvpSpecial,
              ventaN.lines[pos].specialUds,
              ventaN.lines[pos].uds,
              ventaN.lines[pos].dtoMax,
              createPopupQuestion,
              removePopupQuestion,
            );

            const dto = res.dto;
            const pvu = res.pvu;

            ventaN.lines[index].code = response.codigoOPTIWIN;
            ventaN.lines[pos].dto = dto;
            ventaN.lines[pos].pvu = pvu;
            ventaN.lines[index].total =
              ventaN.lines[pos].pvu * ventaN.lines[pos].uds;
            ventaN.lines[index].stock = response.sinControlStock
              ? ""
              : response.stock;

            ventaN = updateVentasTotal(ventaN);

            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
          } else {
            // Found in table, different line
            let ventaN = structuredClone(venta);

            ventaN.lines[pos].uds++;

            const res = calculateDtoFromAll(
              ventaN.lines[pos].pvp,
              venta.patientDto,
              ventaN.lines[pos].pvpOffer,
              ventaN.lines[pos].offerFrom,
              ventaN.lines[pos].offerTo,
              ventaN.lines[pos].pvpSpecial,
              ventaN.lines[pos].specialUds,
              ventaN.lines[pos].uds,
              ventaN.lines[pos].dtoMax,
              createPopupQuestion,
              removePopupQuestion,
            );

            const dto = res.dto;
            const pvu = res.pvu;

            ventaN.lines[pos].code = response.codigoOPTIWIN;
            ventaN.lines[pos].stock = response.sinControlStock
              ? ""
              : response.stock;
            ventaN.lines[pos].dto = dto;
            ventaN.lines[pos].pvu = pvu;
            ventaN.lines[pos].total =
              ventaN.lines[pos].pvu * ventaN.lines[pos].uds;

            ventaN.lines = ventaN.lines.filter((line, i) => {
              return index !== i;
            });

            ventaN = updateVentasTotal(ventaN);

            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
          }
        } else { */
        // Not found in table, replace

        let ventaN = structuredClone(venta);

        const res = calculateDtoFromAll(
          response.pvp,
          venta.patientDto,
          response.pvpOferta,
          response.fechaOfertaInicio,
          response.fechaOfertaFin,
          response.pvpEspecial,
          response.unidadesPvpEspecial,
          1,
          response.dtoMaximo,
          createPopupQuestion,
          removePopupQuestion,
        );

        const dto = res.dto;
        const pvu = res.pvu;

        ventaN.lines[index].dto = dto;

        ventaN.lines[index].code = response.codigoOPTIWIN;
        ventaN.lines[index].description = response.nombre;
        ventaN.lines[index].pvpOr = response.pvp;
        ventaN.lines[index].pvp = response.pvp;
        ventaN.lines[index].ivaOr = response.iva;
        ventaN.lines[index].iva = response.iva;
        ventaN.lines[index].pvu = pvu;
        ventaN.lines[index].uds = 1;
        ventaN.lines[index].total = ventaN.lines[index].pvu;
        ventaN.lines[index].stock = response.sinControlStock
          ? ""
          : response.stock;
        ventaN.lines[index].dtoMax = response.dtoMaximo;
        ventaN.lines[index].pvpOffer = response.pvpOferta;
        ventaN.lines[index].offerFrom = response.fechaOfertaInicio;
        ventaN.lines[index].offerTo = response.fechaOfertaFin;
        ventaN.lines[index].pvpSpecial = response.pvpEspecial;
        ventaN.lines[index].specialUds = response.unidadesPvpEspecial;
        ventaN.lines[index].checkStock = response.sinControlStock;
        ventaN.lines[index].total = ventaN.lines[index].pvu;
        ventaN.lines[index].healthControl = null;
        ventaN.lines[index].provider = response.proveedorNombre;
        ventaN.lines[index].providerId = response.proveedorId;
        ventaN.lines[index].commision = response.comision;
        ventaN.lines[index].ivaBought = response.ivaCompra;

        ventaN.lines[index].lastPurchaseBruto =
          response.precioBrutoUltimaCompra;
        ventaN.lines[index].lastPurchaseNeto = response.precioNetoUltimaCompra;

        ventaN = updateVentasTotal(ventaN);

        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN));

        return true;
        /* } */
      } else {
        // Product not found, empty line
        /* let ventaN = structuredClone(venta);
        ventaN.lines[index].code = code;
        ventaN.lines[index].description = "";
        ventaN.lines[index].pvpOr = 0;
        ventaN.lines[index].pvp = 0;
        ventaN.lines[index].dto =
          ventaN.patientDto !== "" ? ventaN.patientDto : 0;
        ventaN.lines[index].ivaOr = 0;
        ventaN.lines[index].iva = 0;
        ventaN.lines[index].pvu = 0;
        ventaN.lines[index].uds = 1;
        ventaN.lines[index].total = 0;
        ventaN.lines[index].stock = "";
        ventaN.lines[index].dtoMax = "";
        ventaN.lines[index].pvpOffer = "";
        ventaN.lines[index].offerFrom = "";
        ventaN.lines[index].offerTo = "";
        ventaN.lines[index].pvpSpecial = "";
        ventaN.lines[index].specialUds = 2;
        ventaN.lines[index].checkStock = false;
        ventaN.lines[index].healthControl = null;
        ventaN.lines[index].provider = "";
        ventaN.lines[index].providerId = "";
        ventaN.lines[index].commision = "";
        ventaN.lines[index].ivaBought = 0;
        ventaN.lines[index].lastPurchaseBruto = "";
        ventaN.lines[index].lastPurchaseNeto = "";

        ventaN = updateVentasTotal(ventaN);

        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN)); */

        createPopupQuestion(
          "Código no encontrado en almacén.",
          () => {
            const ventaN = structuredClone(venta);
            ventaN.lines[index].code = "";
            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
            removePopupQuestion();
            setTimeout(() => {
              const el = document.getElementById("ntc-" + (index + 1) + "-1");
              if (el) {
                el.focus();
              }
            }, 1);
          },
          null,
          "Entendido",
        );

        return false;
      }
    };

    const selectProduct = async (product, index) => {
      if (product.codigoOPTIWIN !== venta.lines[index].code) {
        // Not the same product, replace
        readProduct(product.codigoOPTIWIN, index);
      }
    };

    const getDocumentIdFromNifType = (idNif) => {
      const docType = documentTypesList.find((d) => d.idNif === idNif);
      return docType ? docType.documentId : "01";
    };

    const loadVenta = async () => {
      setLoading(true);

      let ventaN = structuredClone(newSale);

      setFilterDescription({ id: -1, text: "" });

      loadExencionesIVA();

      if (saleId === -1) {
        setFacturaCompleta(false);
        setRectifyingInvoiceId(-1);
        const opticConfigN = await loadOpticConfig();

        let idPaciente = -1;

        if (orderPatientId === -1) {
          if (createdSale) {
            // La venta viene construida ya de encargo, presupuesto o proforma
            idPaciente = createdSale.idPaciente;
          } else {
            // Venta normal - Paciente 0 (genérico) por defecto

            let response = await post("ObtenerIdentificadorPaciente.php", {
              token: userData.token,
              optica: selectedOptic.id,
              codigoPaciente: orderPatientId !== -1 ? orderPatientId : "0",
            });

            if (response.error === "") {
              idPaciente = response.idPaciente;
            }
          }
        } else {
          // La venta viene de una cesta
          idPaciente = orderPatientId;
        }

        //await loadCashVouchers(idPaciente);

        // Si la óptica no tiene programa de fidelización configurado, la
        // venta se trata como si el paciente no tuviera ninguna tarjeta,
        // sin ni siquiera consultar la suya.
        if (opticConfigN.idFidelizacion !== "") {
          const res = await post("ObtenerPuntosValorPaciente.php", {
            token: userData.token,
            idOptica: selectedOptic.id,
            idCliente: idPaciente,
          });

          setLoyaltyId(res.idFidelizacion);
          setLoyaltyPoints(res.points);
          setLoyaltyPointsValue(
            calculatePointsValue(res.points, loyaltyConfig),
          );
        } else {
          setLoyaltyId("");
          setLoyaltyPoints("");
          setLoyaltyPointsValue("");
        }

        let response = await post("ObtenerDatosPaciente.php", {
          token: userData.token,
          optica: selectedOptic.id,
          idPaciente: idPaciente,
        });

        ventaN.patientDto =
          response.descuentoEspecial == 0 ? "" : response.descuentoEspecial;

        if (createdSale) {
          // Venta ya creada desde encargo, presupuesto o proforma
          ventaN.idPaciente = idPaciente;
          ventaN.codPaciente = createdSale.codPaciente;
          ventaN.name = createdSale.name;
          ventaN.lastName = createdSale.lastName;
          ventaN.address = createdSale.address;
          ventaN.city = createdSale.city;
          ventaN.province = createdSale.province;
          ventaN.postalCode = createdSale.postalCode;
          ventaN.nif = createdSale.nif;
          ventaN.nifType = createdSale.nifType;
          ventaN.tipoDocumento = createdSale.tipoDocumento;
          ventaN.factCodPaciente = response.codigo;
          ventaN.factName = response.nombre + " " + response.apellidos;
          ventaN.factNif = response.nif;
          ventaN.factNifType = response.idNif;
          ventaN.factTipoDocumento = getDocumentIdFromNifType(response.idNif);
          ventaN.factAddress = response.direccion;
          ventaN.factCity = response.localidad;
          ventaN.factProvince = response.provincia;
          ventaN.factPostalCode = response.codigoPostal;
          ventaN.date = moment().format("YYYY-MM-DD HH:mm:ss");
          ventaN.phone = createdSale.phone;
          ventaN.soldBy = createdSale.performedBy;
          ventaN.campaign = createdSale.campaign;
          ventaN.lines = createdSale.lines;
          ventaN.totalDto = createdSale.totalDto;
          ventaN.totalBase = createdSale.totalBase;
          ventaN.totalIVA = createdSale.totalIVA;
          ventaN.total = createdSale.total;
          ventaN.carts = createdSale.carts;
          ventaN.orderNumber = createdSale.orderNumber;
          ventaN.quoteNumber = createdSale.quoteNumber;
          ventaN.proformaNumber = createdSale.proformaNumber;

          let fPerformedBy = agents.find((item) => {
            return item.id === ventaN.soldBy;
          });
          if (!fPerformedBy) {
            fPerformedBy = agents[0];
          }
          setFilterRealizadoPor(fPerformedBy);

          let fDeliveredBy = agents.find((item) => {
            return item.id === ventaN.deliveredBy;
          });
          if (!fDeliveredBy) {
            fDeliveredBy = agents[0];
          }
          setFilterEntregadoPor(fDeliveredBy);

          let fCampaign = campaigns.find((item) => {
            return item.id === ventaN.campaign;
          });
          if (!fCampaign) {
            fCampaign = campaigns[0];
          }

          let n = -1;
          ventaN.lines = ventaN.lines.map((line) => {
            line.id = n;
            n--;
            return line;
          });

          setPaidOr(ventaN.paid);

          setNId(n);
        } else {
          // Nueva venta normal

          ventaN.idPaciente = idPaciente;
          ventaN.codPaciente = response.codigo;
          ventaN.name = response.nombre;
          ventaN.lastName = response.apellidos;
          ventaN.address = response.direccion;
          ventaN.city = response.localidad;
          ventaN.province = response.provincia;
          ventaN.postalCode = response.codigoPostal;
          ventaN.nif = response.nif;
          ventaN.nifType = response.idNif;
          ventaN.tipoDocumento = getDocumentIdFromNifType(response.idNif);
          ventaN.phone = response.telefono;
          ventaN.factCodPaciente = response.codigo;
          ventaN.factName = response.nombre + " " + response.apellidos;
          ventaN.factNif = response.nif;
          ventaN.factNifType = response.idNif;
          ventaN.factTipoDocumento = getDocumentIdFromNifType(response.idNif);
          ventaN.factAddress = response.direccion;
          ventaN.factCity = response.localidad;
          ventaN.factProvince = response.provincia;
          ventaN.factPostalCode = response.codigoPostal;

          ventaN.lines[0].dto =
            ventaN.patientDto === "" ? 0 : ventaN.patientDto;

          ventaN.date = moment().format("YYYY-MM-DD HH:mm:ss");
          ventaN.soldBy = userData.id;
          ventaN.deliveredBy = userData.id;

          let agent = agents.find((item) => {
            return item.id === ventaN.soldBy;
          });
          if (agent) {
            setFilterRealizadoPor(agent);
          }
          agent = agents.find((item) => {
            return item.id === ventaN.deliveredBy;
          });
          if (agent) {
            setFilterEntregadoPor(agent);
          }

          setPaidOr(false);

          if (orderCards.length > 0) {
            // Viene directo de una ficha o del carrito de la pantalla de pacientes

            let n = -1;

            for (let o = 0; o < orderCards.length; o++) {
              const orderCard = orderCards[o];

              /*const res = await post("ObtenerPuntosValorPaciente.php", {
                token: userData.token,
                idOptica: selectedOptic.id,
                idCliente: orderCard.patientId,
              });

              setLoyaltyId(res.idFidelizacion);
              setLoyaltyPoints(res.points);
              setLoyaltyPointsValue(
                calculatePointsValue(res.points, loyaltyConfig)
              );*/

              let resp = await post("ObtenerDatosPaciente.php", {
                token: userData.token,
                optica: selectedOptic.id,
                idPaciente: orderCard.patientId,
              });

              const card = {
                cardId: orderCard.cardId,
                cardType: orderCard.category,
                id: orderCard.cardId,
                patientId: orderCard.patientId,
                patientCode: resp.codigo,
                patientNameLastName: resp.nombre + " " + resp.apellidos,
                selected: true,
                total: orderCard.lines.reduce(
                  (acc, line) => acc + line.total,
                  0,
                ),
                lines: [],
              };

              resp = await post("ObtenerFotoPaciente.php", {
                token: userData.token,
                optica: selectedOptic.id,
                idPaciente: orderCard.patientId,
              });

              card.patientPic = transformPatientPicture(resp.foto);

              for (let i = 0; i < orderCard.lines.length; i++) {
                const l = orderCard.lines[i];
                if (
                  (l.code !== "") & (l.code !== null) &&
                  l.code !== undefined
                ) {
                  let line = structuredClone(newSaleLine);
                  line.id = l.id;
                  line.code = l.code;
                  line.description = l.description;
                  line.pvp = l.pvp;
                  line.dto = l.porcDto;
                  line.iva = l.porcIva;
                  line.pvu = l.pvp - (l.pvp * l.porcDto) / 100;
                  line.total = l.total;
                  line.cardId = orderCard.cardId;
                  line.cardType = orderCard.category;

                  line = await completeLine(line);

                  card.lines.push(line);

                  n--;
                }
              }

              ventaN.carts.push(card);
            }

            // Campaña: motivo seleccionado en la ficha
            const cardCampaign = orderCards.find((o) => o.campaign)?.campaign;
            if (cardCampaign) {
              const fCampaign = campaigns.find(
                (item) => item.text === cardCampaign,
              );
              if (fCampaign) {
                ventaN.campaign = fCampaign.id;
              }
            }

            ventaN = updateVentasTotal(ventaN);

            setNId(n);
          }
        }

        //setEmptySale(emptySale);

        setTimeout(() => {
          const inputPatientCode = document.querySelector(
            "input#codigorec-sale",
          );
          inputPatientCode.focus();
          inputPatientCode.select();
        }, 200);
      } else {
        const opticConfigN = await loadOpticConfig();

        let response = await rpost("ventas/ObtenerVenta.php", {
          token: userData.token,
          idOptica: selectedOptic.id,
          idVenta: saleId,
          nOperacion: "",
        });

        //await loadCashVouchers(response.id_cliente_venta);

        let nFact = "";
        if (response.estado === "Anulada") {
          nFact =
            response.serie_factura_estado + response.numero_factura_estado;
        } else {
          if (response.tipo_factura === "FacturaDeCanje") {
            nFact =
              response.serie_factura_canje + response.numero_factura_canje;
          } else {
            nFact = response.serie_factura + response.numero_factura;
          }
        }

        ventaN.id = response.idVenta;
        ventaN.idPaciente = response.id_cliente_venta;
        ventaN.codPaciente = response.codigo_cliente_venta;
        ventaN.name = response.nombre_cliente_venta;
        ventaN.lastName = response.apellidos_cliente_venta;
        ventaN.address = response.direccion_venta;
        ventaN.city = response.localidad_venta;
        ventaN.province = response.provincia_venta;
        ventaN.postalCode = response.codigo_postal_venta;
        ventaN.nif = response.nif_cliente_venta;
        ventaN.nifType = response.idNifVenta;
        ventaN.tipoDocumento = response.idDocumentoVenta;
        ventaN.factCodPaciente = response.numero_cliente_factura;
        ventaN.factName = response.nombre_cliente_factura;
        ventaN.factNif = response.nif_cliente_factura;
        ventaN.factNifType = response.idNifFactura;
        ventaN.factTipoDocumento = response.idDocumentoFactura;
        ventaN.factAddress = response.direccion_factura;
        ventaN.factCity = response.localidad_factura;
        ventaN.factProvince = response.provincia_factura;
        ventaN.factPostalCode = response.codigo_postal_factura;
        ventaN.factType =
          response.estado === "Anulada"
            ? response.estado
            : response.tipo_factura;
        ventaN.tipoFactura = response.tipo_factura;
        ventaN.serieFactura = response.serie_factura;
        ventaN.numeroFacturaRectificada = response.numero_factura_rectificada;
        ventaN.nOperation = response.nOperacion;
        ventaN.nFact = nFact;
        ventaN.date = response.fecha + " " + response.hora;
        ventaN.phone = response.telefono_venta;
        ventaN.status = response.estado;
        ventaN.observations = response.observaciones;
        ventaN.points = 0;
        ventaN.cashVouncher = 0;
        ventaN.soldBy = -1;
        ventaN.deliveredBy = -1;
        ventaN.campaign = -1;
        ventaN.lines = response.lineas.map((line, index) => {
          return {
            id: index,
            code: line.codigo,
            description: line.descripcion,
            pvpOr: -1,
            pvp: line.pvp_bruto_coniva,
            dto: line.dto,
            ivaOr: -1,
            iva: line.tipo_iva,
            pvu: line.pvp_neto_coniva,
            uds: line.cantidad,
            total: line.total,
            stock: -1,
            dtoMax: "",
            pvpOffer: "",
            offerFrom: "",
            offerTo: "",
            pvpSpecial: "",
            specialUds: 2,
            checkStock: false,
            healthControl: null,
            provider: line.proveedor,
            providerId: line.idProveedor,
            commision: "",
            ivaBought: 0,
            cardId: line.id_ficha,
            cardType: line.tipo_ficha,
            lastPurchaseBruto: "",
            lastPurchaseNeto: "",
            exencionCodigo: line.exencionCodigo ?? "",
            exencionDescripcion: line.exencionDescripcion ?? "",
          };
        });
        ventaN.paid = response.pagado;
        ventaN.delivered = false;
        ventaN.totalDto = 0;
        ventaN.totalBase = 0;
        ventaN.totalIVA = 0;
        ventaN.total = 0;
        ventaN.totalPaid = 0;
        ventaN.totalRemaining = 0;
        ventaN.payments = response.pagos.map((pago) => {
          return {
            id: pago.idPago,
            date: pago.fecha,
            paid: pago.abono,
            method: pago.deudaCancelada ? "DEUDA CANCELADA" : pago.formaPago,
            card: pago.tipoTarjeta,
          };
        });
        ventaN.ivas = response.ivas.map((iva) => {
          return {
            percIva: iva.tipo,
            base: iva.base,
            iva: iva.iva,
            total: iva.total,
          };
        });

        response.lineas.forEach((line) => {
          ventaN.totalDto += line.dto_coniva * line.cantidad;
          ventaN.totalBase += line.base * line.cantidad;
          ventaN.totalIVA += line.iva * line.cantidad;
          ventaN.total += line.total;
        });

        response.pagos.forEach((pago) => {
          if (pago.abono >= 0) {
            ventaN.totalPaid += pago.abono;
          }
        });
        ventaN.totalRemaining = ventaN.total - ventaN.totalPaid;

        let fPerformedBy = agents.find((item) => {
          return item.text === response.empleado;
        });
        if (!fPerformedBy) {
          fPerformedBy = agents[0];
        }
        ventaN.soldBy = fPerformedBy.id;
        setFilterRealizadoPor(fPerformedBy);

        let fDeliveredBy = agents.find((item) => {
          return item.text === response.entregado_por;
        });
        if (!fDeliveredBy) {
          fDeliveredBy = agents[0];
        }
        ventaN.deliveredBy = fDeliveredBy.id;
        setFilterEntregadoPor(fDeliveredBy);
        if (fDeliveredBy.text !== "") {
          ventaN.delivered = true;
        }

        // La descripción guardada puede no estar ya entre las opciones; en
        // ese caso se conserva el texto tal cual (la venta cerrada lo muestra
        // en un campo de solo lectura).
        const descripcion = response.descripcion ?? "";
        setFilterDescription(
          opticConfigN.descriptionOptions.find(
            (item) => item.text === descripcion.toUpperCase(),
          ) || {
            id: -1,
            text: descripcion,
          },
        );

        let fCampaign = campaigns.find((item) => {
          return item.text === response.motivo_agente;
        });
        if (!fCampaign) {
          fCampaign = campaigns[0];
        }
        ventaN.campaign = fCampaign.id;

        if (response.cross_selling) {
          ventaN.crossSelling = structuredClone(newCrossSelling);
          ventaN.crossSelling.nOperation = response.venta_origen_cross_selling;
          ventaN.crossSelling.type = response.tipo_cross_selling;
          ventaN.crossSelling.agent = response.empleado_cross_selling;
        }

        /*const res = await post("ObtenerPuntosValorPaciente.php", {
          token: userData.token,
          idOptica: selectedOptic.id,
          idCliente: ventaN.idPaciente,
        });

        setLoyaltyId(res.idFidelizacion);
        setLoyaltyPoints(res.points);
        setLoyaltyPointsValue(calculatePointsValue(res.points, loyaltyConfig));*/

        let res = await post("ObtenerPuntosVenta.php", {
          token: userData.token,
          idVenta: saleId,
        });
        setLoyaltyId(res.idFidelizacion);
        setLoyaltyPoints(res.puntosCanjeados);
        setLoyaltyPointsValue(res.contravalorCanjeado);
        setLoyaltyPointsGenerated(res.puntosGenerados);
        setLoyaltyPointsGeneratedValue(res.contravalorGenerado);

        response = await post("ObtenerDatosPaciente.php", {
          token: userData.token,
          optica: selectedOptic.id,
          idPaciente: ventaN.idPaciente,
        });

        ventaN.patientDto =
          response.descuentoEspecial == 0 ? "" : response.descuentoEspecial;

        setPaidOr(ventaN.paid);

        //setEmptySale(ventaN);
      }

      const campaign = campaigns.find((item) => {
        return item.id == ventaN.campaign;
      });
      if (campaign) {
        setFilterCampaign(campaign);
      }

      ventaN = createIVASummary(ventaN);

      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));

      setTotalDtoF(formatCurrency(ventaN.totalDto));
      setTotalBaseF(formatCurrency(ventaN.totalBase));
      setTotalIVAF(formatCurrency(ventaN.totalIVA));
      setTotalPaidF(formatCurrency(ventaN.totalPaid));
      setTotalRemainingF(formatCurrency(ventaN.totalRemaining));

      /*if (saleId === -1) {
        setEmptySale(ventaN);
      }*/

      if (
        (saleId === -1 &&
          orderCards.length === 0 &&
          orderPatientId === -1 &&
          createdSale === null) ||
        saleId !== -1
      ) {
        setEmptySale(ventaN);
      } else {
        setEmptySale(emptySale);
      }

      setLoading(false);
    };

    const createNewRow = () => {
      const pos = venta.lines.findIndex((line) => {
        return line.code.trim() === "" && line.description.trim() === "";
      });
      if (pos === -1) {
        const item = structuredClone(newSaleLine);
        item.dto = venta.patientDto === "" ? 0 : venta.patientDto;
        item.id = nId - 1;
        let ventaN = structuredClone(venta);
        ventaN.lines.push(item);
        ventaN = updateVentasTotal(ventaN);
        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN));
        setNId(nId - 1);
        setTimeout(() => {
          const el = document.getElementById(
            "ntc-" + (venta.lines.length + 1) + "-1",
          );
          if (el) {
            el.focus();
          }
        }, 100);
      } else {
        const el = document.getElementById("ntc-" + (pos + 1) + "-1");
        if (el) {
          el.focus();
        }
      }
    };

    const removeLine = (index) => {
      let ventaN = structuredClone(venta);
      ventaN.lines = ventaN.lines.filter((line, i) => {
        return i !== index;
      });

      ventaN = updateVentasTotal(ventaN);

      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));

      if (ventaN.lines.length === 0) {
        setForceCreateNewRow(true);
      }
    };

    const createIVASummary = (v) => {
      const ivas = [];
      v.lines.forEach((line) => {
        if (line.code.trim() !== "" || line.description.trim() !== "") {
          const percIva = parseInt(line.iva);
          const base = (line.pvu / (1 + line.iva / 100)) * line.uds;
          const iva = line.pvu * line.uds - base;
          const total = line.total;
          let ivaInfo = ivas.find((i) => {
            return i.percIva === percIva;
          });
          if (!ivaInfo) {
            ivaInfo = {
              percIva,
              base,
              iva,
              total,
            };
            ivas.push(ivaInfo);
          } else {
            ivaInfo.base += base;
            ivaInfo.iva += iva;
            ivaInfo.total += total;
          }
        }
      });

      v.carts.forEach((cart) => {
        cart.lines.forEach((line) => {
          const percIva = parseInt(line.iva);
          const base = (line.pvu / (1 + line.iva / 100)) * line.uds;
          const iva = line.pvu * line.uds - base;
          const total = line.total;
          let ivaInfo = ivas.find((i) => {
            return i.percIva === percIva;
          });
          if (!ivaInfo) {
            ivaInfo = {
              percIva,
              base,
              iva,
              total,
            };
            ivas.push(ivaInfo);
          } else {
            ivaInfo.base += base;
            ivaInfo.iva += iva;
            ivaInfo.total += total;
          }
        });
      });

      v.ivas = ivas;
      return v;
    };

    const updateVentasTotal = (v) => {
      let totalDto = 0;
      let totalBase = 0;
      let totalIVA = 0;
      let total = 0;
      const clearExemption = (line) => {
        if (!isExemptionEnabled(line.iva)) {
          line.exencionCodigo = "";
          line.exencionDescripcion = "";
        }
      };
      v.lines.forEach((line) => {
        clearExemption(line);
        //totalDto = totalDto + line.pvp * (line.dto / 100) * line.uds;
        totalDto = totalDto + line.pvp * line.uds - line.pvu * line.uds;
        const base = (line.pvu / (1 + line.iva / 100)) * line.uds;
        totalBase += base;
        totalIVA = totalIVA + (line.pvu * line.uds - base);
        total = total + line.total;
      });
      v.carts.forEach((cart) => {
        cart.lines.forEach((line) => {
          clearExemption(line);
          //totalDto = totalDto + line.pvp * (line.dto / 100) * line.uds;
          totalDto = totalDto + line.pvp * line.uds - line.pvu * line.uds;
          const base = (line.pvu / (1 + line.iva / 100)) * line.uds;
          totalBase += base;
          totalIVA = totalIVA + (line.pvu * line.uds - base);
          total = total + line.total;
        });
      });
      v.totalDto = Math.round(totalDto * 100) / 100;
      v.totalBase = Math.round(totalBase * 100) / 100;
      v.totalIVA = Math.round(totalIVA * 100) / 100;
      v.total = Math.round(total * 100) / 100;
      v = createIVASummary(v);
      setTotalDtoF(formatCurrency(v.totalDto));
      setTotalBaseF(formatCurrency(v.totalBase));
      setTotalIVAF(formatCurrency(v.totalIVA));

      if (v.total >= MAX_IMPORTE_FACTURA) {
        setFacturaCompleta(true);
      }
      return v;
    };

    const toggleShowFactData = () => {
      setShowFactData(!showFactData);
    };

    const onSelectPatient = async (e) => {
      const ventaN = structuredClone(venta);
      ventaN.idPaciente = e.idPaciente;
      ventaN.codPaciente = e.codigo;
      ventaN.name = e.nombre;
      ventaN.lastName = e.apellidos;
      ventaN.address = e.direccion;
      ventaN.city = e.localidad;
      ventaN.province = e.provincia;
      ventaN.postalCode = e.codigoPostal;
      ventaN.nif = e.nif;
      ventaN.tipoDocumento = e.idDocumento;
      ventaN.nifType = e.idNif;
      ventaN.phone = e.telefono;
      ventaN.factCodPaciente = e.codigo;
      ventaN.factName = e.nombre + " " + e.apellidos;
      ventaN.factNif = e.nif;
      ventaN.factTipoDocumento = e.idDocumento;
      ventaN.factNifType = e.idNif;
      ventaN.factAddress = e.direccion;
      ventaN.factCity = e.localidad;
      ventaN.factProvince = e.provincia;
      ventaN.factPostalCode = e.codigoPostal;
      ventaN.patientDto = e.descuento;

      ventaN.lines.forEach((line) => {
        if (line.code.trim() === "" && line.description.trim() === "") {
          line.dto = ventaN.patientDto;
          line.pvu = calculatePVU(line.pvp, line.dto);
          line.total = line.pvu * line.uds;
        }
      });

      const res = await post("ObtenerPuntosValorPaciente.php", {
        token: userData.token,
        idOptica: selectedOptic.id,
        idCliente: ventaN.idPaciente,
      });

      setLoyaltyId(res.idFidelizacion);
      setLoyaltyPoints(res.points);
      setLoyaltyPointsValue(calculatePointsValue(res.points, loyaltyConfig));

      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));

      //loadCashVouchers(e.idPaciente);

      const el = document.querySelector(
        "div.rdt_TableRow > div:first-child input",
      );
      if (el) {
        el.focus();
      }
    };

    const onChangeNombre = (e) => {
      const ventaN = structuredClone(venta);
      ventaN.name = e;
      setVenta(ventaN);
    };

    const onChangeApellidos = (e) => {
      const ventaN = structuredClone(venta);
      ventaN.lastName = e;
      setVenta(ventaN);
    };

    const onChangeDni = (e) => {
      const ventaN = structuredClone(venta);
      ventaN.nif = e;
      setVenta(ventaN);
    };

    const onChangePhone = (e) => {
      const ventaN = structuredClone(venta);
      ventaN.phone = e;
      setVenta(ventaN);
    };

    const onLinkPatient = () => {
      if (venta.codPaciente !== "") {
        window.open(`/patient-datos/${venta.idPaciente}`);
      }
    };

    const onChangeFilterRealizadoPor = (e) => {
      const ventaN = structuredClone(venta);
      ventaN.soldBy = e.id;
      setVenta(ventaN);
      setFilterRealizadoPor(e);
    };

    const onChangeFilterEntregadoPor = (e) => {
      if (e.id !== venta.deliveredBy) {
        const ventaN = structuredClone(venta);
        ventaN.deliveredBy = e.id;
        ventaN.delivered = e.id !== -1;
        setVenta(ventaN);
        setFilterEntregadoPor(e);

        if (venta.id !== -1) {
          deliverSale(ventaN);
        }
      }
    };

    // En una venta nueva, "Vendido por" y "Entregado por" del popup de pago son
    // los mismos que los de la pantalla de la venta: se mantienen sincronizados
    // aunque luego se cancele el pago.
    const onChangeFilterRealizadoPorPayment = (e) => {
      const paymentN = structuredClone(payment);
      paymentN.soldBy = e;
      setPayment(paymentN);

      if (saleId === -1) {
        const ventaN = structuredClone(venta);
        ventaN.soldBy = e.id;
        setVenta(ventaN);
        setFilterRealizadoPor(e);
      }
    };

    const onChangeFilterEntregadoPorPayment = (e) => {
      const paymentN = structuredClone(payment);
      paymentN.deliveredBy = e;
      setPayment(paymentN);

      if (saleId === -1) {
        const ventaN = structuredClone(venta);
        ventaN.deliveredBy = e.id;
        ventaN.delivered = e.id !== -1;
        setVenta(ventaN);
        setFilterEntregadoPor(e);
      }
    };

    const onChangeFilterCampaign = (e) => {
      const ventaN = structuredClone(venta);
      ventaN.campaign = e.id;
      setVenta(ventaN);
      setFilterCampaign(e);
    };

    const toggleFacturaCompleta = () => {
      setFacturaCompleta(
        venta.total >= MAX_IMPORTE_FACTURA ? true : !facturaCompleta,
      );
    };

    const onChangePVPLine = (value, row) => {
      let pvp = value;
      if (pvp < 0) {
        pvp = 0;
      }
      let ventaN = structuredClone(venta);
      const line = getLineRef(ventaN, row);
      line.pvp = pvp;
      line.pvu = calculatePVU(line.pvp, line.dto);
      line.total = line.pvu * line.uds;

      ventaN = updateVentasTotal(ventaN);

      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));
    };

    const onChangeDtoLine = (value, row) => {
      let ventaN = structuredClone(venta);
      const line = getLineRef(ventaN, row);
      if (line.dtoMax !== "" && value > line.dtoMax) {
        createPopupQuestion(
          "El descuento introducido (" +
            value +
            "%) no debe ser mayor al descuento máximo permitido por el producto (" +
            line.dtoMax +
            "%).",
          () => {
            const dto = getLineRef(venta, row).dto;
            line.dto = 1;
            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
            removePopupQuestion();
            setTimeout(() => {
              line.dto = dto;
              setVenta(ventaN);
              setVentaLinesTable(createVentaLinesTable(ventaN));
              removePopupQuestion();
              const el = document.querySelector(
                "#ntc-" + (row.index + 1) + "-4",
              );
              if (el) {
                el.focus();
              }
            }, 1);
          },
          null,
          "Cerrar",
        );
      } else {
        let dto = value;
        if (dto < 0) {
          dto = 0;
        }
        if (dto > 100) {
          dto = 100;
        }
        line.dto = dto;
        line.pvu = calculatePVU(line.pvp, line.dto);
        line.total = line.pvu * line.uds;

        ventaN = updateVentasTotal(ventaN);

        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN));
      }
    };

    const onChangePVULine = (value, row) => {
      let pvu = parseFloat(value) || 0;
      const pvp = parseFloat(getLineRef(venta, row).pvp) || 0;
      if (pvu > pvp) {
        pvu = pvp;
      }
      if (pvu < 0) {
        pvu = 0;
      }
      let ventaN = structuredClone(venta);
      const line = getLineRef(ventaN, row);
      line.pvu = pvu;
      line.dto = calculateDto(line.pvp, line.pvu);
      line.total = line.pvu * line.uds;

      ventaN = updateVentasTotal(ventaN);

      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));
    };

    const onChangeTotalLine = (value, row) => {
      const totalN = parseFloat(value);
      const line = getLineRef(venta, row);

      const linesN = [
        {
          id: line.code === "" ? line.description : line.code,
          total: line.total,
          dto: parseFloat(line.dto) || 0,
          dtoMax: line.code === "" ? "" : line.dtoMax,
        },
      ];

      const result = calculateDtos(linesN, totalN, false);
      if (result.error === "") {
        let ventaN = structuredClone(venta);
        const l = getLineRef(ventaN, row);
        l.total = result.lines[0].total;
        l.dto = result.lines[0].dto;
        l.pvu = l.total / l.uds;

        ventaN = updateVentasTotal(ventaN);

        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN));
      } else {
        createPopupQuestion(result.error, removePopupQuestion, null);
        const totalOr = line.total;
        let ventaN = structuredClone(venta);
        getLineRef(ventaN, row).total = totalN;
        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN));
        setTimeout(() => {
          let ventaN2 = structuredClone(venta);
          getLineRef(ventaN2, row).total = totalOr;
          setVenta(ventaN2);
          setVentaLinesTable(createVentaLinesTable(ventaN2));
        }, 100);
      }
    };

    const onChangeUdsLine = (value, row) => {
      let uds = value;
      if (uds < 0) {
        uds = 0;
      }
      let ventaN = structuredClone(venta);
      const line = getLineRef(ventaN, row);

      line.uds = uds;

      const res = calculateDtoFromAll(
        line.pvp,
        venta.patientDto,
        line.pvpOffer,
        line.offerFrom,
        line.offerTo,
        line.pvpSpecial,
        line.specialUds,
        line.uds,
        line.dtoMax,
        createPopupQuestion,
        removePopupQuestion,
      );

      // Se conserva el descuento actual de la línea (manual o calculado) salvo
      // que la oferta o el precio especial por unidades den uno mayor.
      if (res.dto > (parseFloat(line.dto) || 0)) {
        line.dto = res.dto;
        line.pvu = res.pvu;
      } else {
        line.pvu = calculatePVU(line.pvp, line.dto);
      }
      line.total = line.pvu * line.uds;

      ventaN = updateVentasTotal(ventaN);

      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));
    };

    const onChangeIVALine = (value, row) => {
      const pos = tiposIVA.findIndex((iva) => {
        return iva == value;
      });

      if (pos === -1) {
        createPopupQuestion("Tipo de IVA inválido: " + value + "%.", () => {
          const iva = getLineRef(venta, row).iva;
          let ventaN = structuredClone(venta);
          const line = getLineRef(ventaN, row);
          line.iva = 0;
          setVenta(ventaN);
          setVentaLinesTable(createVentaLinesTable(ventaN));
          removePopupQuestion();
          setTimeout(() => {
            line.iva = iva;
            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
            const el = document.querySelector("#ntc-" + (row.index + 1) + "-5");
            if (el) {
              el.focus();
            }
          }, 1);
        });
      } else {
        let ventaN = structuredClone(venta);
        const line = getLineRef(ventaN, row);

        if (value == IVASuperRed && line.iva != IVASuperRed) {
          // IVA Especial
          const result = calculateIVASuperRed(
            line.pvp,
            line.dto,
            line.uds,
            IVASuperRed,
          );

          line.pvp = result.pvp;
          line.pvu = result.pvu;
          line.total = result.total;
        }

        line.iva = value;

        ventaN = updateVentasTotal(ventaN);

        setVenta(ventaN);
        setVentaLinesTable(createVentaLinesTable(ventaN));
      }
    };

    const showInvoicePopup = (show) => {
      const invoiceN = show
        ? {
            codPaciente: venta.factCodPaciente,
            name: venta.factName,
            nif: venta.factNif,
            tipoDocumento: venta.factTipoDocumento,
            nifType: venta.factNifType,
            address: venta.factAddress,
            city: venta.factCity,
            province: venta.factProvince,
            postalCode: venta.factPostalCode,
          }
        : null;
      setInvoice(invoiceN);
      if (!show) {
        setGeneratingInvoice(false);
      } else {
        setTimeout(() => {
          const inputCodPaciente = document.querySelector(
            "input#codigorec-fact",
          );
          if (inputCodPaciente) {
            inputCodPaciente.focus();
            inputCodPaciente.select();
          }
        }, 200);
      }
    };

    const onSelectFactPatient = (e) => {
      const ventaN = structuredClone(venta);
      ventaN.factCodPaciente = e.codigo;
      ventaN.factName = e.nombre + " " + e.apellidos;
      ventaN.factNif = e.nif;
      ventaN.factTipoDocumento = e.idDocumento;
      ventaN.factNifType = e.idNif;
      ventaN.factAddress = e.direccion;
      ventaN.factCity = e.localidad;
      ventaN.factProvince = e.provincia;
      ventaN.factPostalCode = e.codigoPostal;
      setVenta(ventaN);

      const invoiceN = structuredClone(invoice);
      invoiceN.codPaciente = ventaN.factCodPaciente;
      invoiceN.name = ventaN.factName;
      invoiceN.nif = ventaN.factNif;
      invoiceN.tipoDocumento = ventaN.factTipoDocumento;
      invoiceN.nifType = ventaN.factNifType;
      invoiceN.address = ventaN.factAddress;
      invoiceN.city = ventaN.factCity;
      invoiceN.province = ventaN.factProvince;
      invoiceN.postalCode = ventaN.factPostalCode;
      setInvoice(invoiceN);
    };

    const onChangeFactName = (e) => {
      const invoiceN = structuredClone(invoice);
      invoiceN.name = e;
      setInvoice(invoiceN);
    };

    const onChangeFactNIF = (e) => {
      const invoiceN = structuredClone(invoice);
      invoiceN.nif = e;
      setInvoice(invoiceN);
    };

    const onChangeFactAddress = (e) => {
      const invoiceN = structuredClone(invoice);
      invoiceN.address = e;
      setInvoice(invoiceN);
    };

    const onChangeFactPostalCode = (e) => {
      const invoiceN = structuredClone(invoice);
      invoiceN.postalCode = e;
      setInvoice(invoiceN);
    };

    const onChangeFactCity = (e) => {
      const invoiceN = structuredClone(invoice);
      invoiceN.city = e;
      setInvoice(invoiceN);
    };

    const onChangeFactProvince = (e) => {
      const invoiceN = structuredClone(invoice);
      invoiceN.province = e.id;
      setInvoice(invoiceN);
    };

    const onChangePaymentMethod = async (e) => {
      let paymentN = structuredClone(payment);
      paymentN.paymentMethod = e;

      let posT = paymentMethods.find((item) => {
        return item.text === "TARJETA";
      });
      if (posT && posT.id !== e.id) {
        paymentN.cardType = cardTypes[0];
      }

      posT = paymentMethods.find((item) => {
        return item.text === "VALE DE CAJA";
      });
      if (posT && posT.id === e.id) {
        const response = await post("support/ValesCaja/ListarValesCaja.php", {
          token: userData.token,
          idCliente: venta.idPaciente,
        });

        let cashVouchersN = response.filter((voucher) => !voucher.canjeado);

        cashVouchersN = cashVouchersN.map((voucher) => ({
          id: voucher.id,
          text: formatCurrency(parseFloat(voucher.importe)),
          value: parseFloat(voucher.importe),
        }));

        paymentN.cashVoucher =
          cashVouchersN.length > 0 ? cashVouchersN[0] : null;

        paymentN.delivered = paymentN.cashVoucher
          ? paymentN.cashVoucher.value
          : 0;

        paymentN = calculatePayment(paymentN);

        setCashVouchers(cashVouchersN);
      } else {
        paymentN.cashVoucher = null;
      }

      setPayment(paymentN);
    };

    const onChangePaymentTotal = (e) => {
      const paymentN = structuredClone(payment);
      paymentN.paid = e;
      setPayment(paymentN);
    };

    const onChangeCardType = (e) => {
      const paymentN = structuredClone(payment);
      paymentN.cardType = e;
      setPayment(paymentN);
    };

    const onChangeCashVoucher = (e) => {
      let paymentN = structuredClone(payment);
      paymentN.cashVoucher = e;
      paymentN.delivered = e ? e.value : 0;
      paymentN = calculatePayment(paymentN);
      setPayment(paymentN);
    };

    const onTogglePaymentReceipt = (field) => {
      const paymentN = structuredClone(payment);
      paymentN[field] = !paymentN[field];
      setPayment(paymentN);
    };

    const onEditPayment = (paymentId) => {
      const paymentItem = venta.payments.find((item) => item.id === paymentId);
      if (!paymentItem) {
        return;
      }

      const otherPaymentsTotal = venta.payments.reduce((acc, item) => {
        return item.id === paymentId ? acc : acc + item.paid;
      }, 0);

      const paymentMethod =
        paymentMethods.find((item) => item.text === paymentItem.method) ||
        paymentMethods[0];
      const cardType =
        cardTypes.find((item) => item.text === paymentItem.card) ||
        cardTypes[0];

      const delivered = paymentItem.paid;

      setEditPayment({
        id: paymentItem.id,
        paymentMethod,
        cardType,
        soldBy: filterRealizadoPor,
        total: venta.total,
        otherPaymentsTotal,
        delivered,
        pending: venta.total - (otherPaymentsTotal + delivered),
      });

      setTimeout(() => {
        const el = document.querySelector("#p-edit-payment-delivered");
        if (el) {
          el.focus();
          setTimeout(() => {
            el.select();
          }, 1);
        }
      });
    };

    const closeEditPayment = () => {
      setEditPayment(null);
    };

    const onChangeEditPaymentMethod = (e) => {
      const editPaymentN = structuredClone(editPayment);
      editPaymentN.paymentMethod = e;

      const posT = paymentMethods.find((item) => {
        return item.text === "TARJETA";
      });
      if (posT && posT.id !== e.id) {
        editPaymentN.cardType = cardTypes[0];
      }

      setEditPayment(editPaymentN);
    };

    const onChangeEditPaymentCardType = (e) => {
      const editPaymentN = structuredClone(editPayment);
      editPaymentN.cardType = e;
      setEditPayment(editPaymentN);
    };

    const onChangeEditPaymentSoldBy = (e) => {
      const editPaymentN = structuredClone(editPayment);
      editPaymentN.soldBy = e;
      setEditPayment(editPaymentN);
    };

    const onChangeEditPaymentDelivered = (e) => {
      const delivered = parseFloat(e.replace(",", ".")) || 0;
      const totalPagos = editPayment.otherPaymentsTotal + delivered;

      if (totalPagos > editPayment.total) {
        createPopupQuestion(
          "El importe introducido hace que el total de pagos supere al total de la compra.",
          () => {
            const editPaymentN = structuredClone(editPayment);
            editPaymentN.delivered = "";
            editPaymentN.pending =
              editPaymentN.total - editPaymentN.otherPaymentsTotal;
            setEditPayment(editPaymentN);
            setEditPaymentDeliveredKey((k) => k + 1);
            removePopupQuestion();
            setTimeout(() => {
              const el = document.getElementById("p-edit-payment-delivered");
              if (el) {
                el.focus();
              }
            }, 1);
          },
          null,
          "Entendido",
        );
        return;
      }

      const editPaymentN = structuredClone(editPayment);
      editPaymentN.delivered = delivered;
      editPaymentN.pending = editPaymentN.total - totalPagos;
      setEditPayment(editPaymentN);
    };

    const saveEditPayment = async () => {
      await rpost("ventas/EditarPago.php", {
        token: userData.token,
        idPago: editPayment.id,
        abono: editPayment.delivered,
        formaPago: editPayment.paymentMethod.text,
        tipoTarjeta: editPayment.cardType.text,
        empleado: editPayment.soldBy.text,
      });

      setEditPayment(null);
      loadVenta();
    };

    const showAddressPopup = (show) => {
      const address = show
        ? {
            address: venta.address,
            city: venta.city,
            province: venta.province,
            postalCode: venta.postalCode,
          }
        : null;
      setAddress(address);
    };

    const onChangeAddress = (e) => {
      const addressN = structuredClone(address);
      addressN.address = e;
      setAddress(addressN);
    };

    const onChangePostalCode = (e) => {
      const addressN = structuredClone(address);
      addressN.postalCode = e;
      setAddress(addressN);
    };

    const onChangeCity = (e) => {
      const addressN = structuredClone(address);
      addressN.city = e;
      setAddress(addressN);
    };

    const onChangeProvince = (e) => {
      const addressN = structuredClone(address);
      addressN.province = e.id;
      setAddress(addressN);
    };

    const saveAddress = () => {
      const ventaN = structuredClone(venta);
      ventaN.address = address.address;
      ventaN.city = address.city;
      ventaN.province = address.province;
      ventaN.postalCode = address.postalCode;
      setVenta(ventaN);
      setAddress(null);
    };

    const getValidLines = (considerCarts) => {
      const lines = [];
      venta.lines.forEach((line) => {
        if (line.code.trim() !== "" || line.description.trim() !== "") {
          lines.push(line);
        }
      });
      if (considerCarts) {
        venta.carts.forEach((cart) => {
          cart.lines.forEach((line) => {
            lines.push(line);
          });
        });
      }
      return lines;
    };

    const onBlurTotal = (e) => {
      let error = "";
      const totalN = parseFloat(e.replace(",", "."));
      if (totalN !== venta.total) {
        const linesWithIndex = [];
        venta.lines.forEach((line, index) => {
          if (line.code.trim() !== "" || line.description.trim() !== "") {
            linesWithIndex.push({ line, index });
          }
        });
        if (linesWithIndex.length > 0) {
          const linesN = linesWithIndex.map(({ line }) => {
            return {
              id: line.code === "" ? line.description : line.code,
              total: line.total,
              dto: parseFloat(line.dto) || 0,
              dtoMax: line.code === "" ? "" : line.dtoMax,
            };
          });

          // Calculate discount (only applicable to product lines, no carts)
          const linesTotalProducts = linesN.reduce(
            (acc, curr) => (acc += curr.total),
            0,
          );
          let linesTotalCarts = 0;
          venta.carts.forEach((cart) => {
            cart.lines.forEach((cartLine) => {
              linesTotalCarts += cartLine.total;
            });
          });
          const total = linesTotalProducts + linesTotalCarts;
          const reduction = total - totalN;
          const linesTotal = linesTotalProducts - reduction;

          const result = calculateDtos(linesN, linesTotal, false);
          if (result.error === "") {
            let ventaN = structuredClone(venta);
            result.lines.forEach((line, i) => {
              // calculateDtos devuelve result.lines en el mismo orden que
              // linesN, así que reemparejamos por posición (linesWithIndex[i])
              // en vez de por código, para no confundir líneas con datos
              // idénticos (p. ej. el mismo producto en varias líneas).
              const l = ventaN.lines[linesWithIndex[i].index];
              if (l) {
                l.total = line.total;
                l.pvu = l.total / l.uds;
                l.dto = line.dto;
              }
            });

            ventaN = updateVentasTotal(ventaN);
            ventaN.total = parseFloat(e.replace(",", "."));

            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
          } else {
            error = result.error;
          }
        } else {
          error = "Debe insertar productos en la venta.";
        }
      }
      if (error !== "") {
        createPopupQuestion(error, removePopupQuestion, null);
        const totalOr = venta.total;
        const ventaN = structuredClone(venta);
        ventaN.total = totalN;
        setVenta(ventaN);
        setTimeout(() => {
          const ventaN = structuredClone(venta);
          ventaN.total = totalOr;
          setVenta(ventaN);
        }, 100);
      }
    };

    const saveInvoice = () => {
      if (
        invoice.name.trim() === "" ||
        invoice.nif.trim() === "" ||
        invoice.address.trim() === "" ||
        invoice.city.trim() === "" ||
        invoice.province.trim() === "" ||
        invoice.postalCode.trim() === ""
      ) {
        createPopupQuestion(
          `Debe rellenar todos los campos.`,
          removePopupQuestion,
          null,
        );
        return;
      }
      if (
        (invoice.tipoDocumento ? invoice.tipoDocumento : "01") === "01" &&
        !validateNIF(invoice.nif)
      ) {
        createPopupQuestion(
          "Número de DNI / CIF incorrecto.",
          removePopupQuestion,
          null,
          "Entendido",
        );
        return;
      }
      const ventaN = structuredClone(venta);
      ventaN.factName = invoice.name;
      ventaN.factNif = invoice.nif;
      ventaN.factTipoDocumento = invoice.tipoDocumento;
      ventaN.factNifType = invoice.nifType;
      ventaN.factAddress = invoice.address;
      ventaN.factCity = invoice.city;
      ventaN.factProvince = invoice.province;
      ventaN.factPostalCode = invoice.postalCode;
      setVenta(ventaN);
      setInvoice(null);
    };

    const onRemoveCart = (cartId) => {
      const cart = venta.carts.find((c) => c.id === cartId);
      if (cart) {
        createPopupQuestion(
          `¿Desea devolver este elemento a la cesta de ${cart.patientNameLastName}?`,
          () => {
            let ventaN = structuredClone(venta);
            ventaN.carts = ventaN.carts.filter((c) => c.id !== cartId);
            ventaN = updateVentasTotal(ventaN);
            setVenta(ventaN);
            setVentaLinesTable(createVentaLinesTable(ventaN));
            removePopupQuestion();
          },
          removePopupQuestion,
        );
      }
    };

    const loadCarts = async () => {
      const response = await rpost("ventas/ListarCestas.php", {
        token: userData.token,
        idOptica: selectedOptic.id,
      });

      let cartsN = response.map((cart) => {
        const lines = cart.lineas.map((line) => {
          const l = {
            id: "c-" + line.id,
            code: line.codigoOPTIWIN,
            description: line.descripcion,
            pvp: line.pvp,
            dto: line.porcDto,
            iva: line.porcIVA,
            pvu: line.pvp - (line.pvp * line.porcDto) / 100,
            uds: 1,
            total: line.total,
            stock: line.stock,
            cardId: cart.idFicha,
            cardType:
              cart.categoria === "gafas" && cart.sol ? "SOL" : cart.categoria,
          };

          return l;
        });

        return {
          id: cart.idFicha,
          cardType:
            cart.categoria === "gafas" && cart.sol ? "SOL" : cart.categoria,
          patientCode: cart.codigoCliente,
          patientId: cart.idCliente,
          patientNameLastName: cart.nombreCliente,
          total: cart.total,
          lines,
        };
      });

      cartsN = cartsN.reduce((acc, curr) => {
        const pos = venta.carts.findIndex((cart) => {
          return cart.id === curr.id;
        });
        if (pos === -1) {
          acc.push({
            id: curr.id,
            patientId: curr.patientId,
            patientCode: curr.patientCode,
            patientNameLastName: curr.patientNameLastName,
            patientPic: "",
            cardType: curr.cardType,
            total: curr.total,
            lines: curr.lines,
            selected: false,
            cardId: curr.id,
          });
        }
        return acc;
      }, []);

      setCartPopup(cartsN);
      loadCartsPictures(cartsN);
    };

    const loadCartsPictures = async (carts) => {
      const cartsN = structuredClone(carts);
      for (let i = 0; i < cartsN.length; i++) {
        const cart = cartsN[i];
        const response = await post("ObtenerFotoPaciente.php", {
          token: userData.token,
          optica: selectedOptic.id,
          idPaciente: cart.patientId,
        });
        cart.patientPic = response.foto ? response.foto : "/images/avatar.svg";
      }

      setCartPopup(cartsN);
    };

    const onClickCartItem = (index) => {
      const carts = structuredClone(cartPopup);
      carts[index].selected = !carts[index].selected;
      setCartPopup(carts);
    };

    const completeLine = async (line) => {
      const response = await post("ObtenerProducto.php", {
        token: userData.token,
        codigo: line.code,
        idOptica: selectedOptic.id,
      });
      if (response.codigoOPTIWIN) {
        line.pvpOr = response.pvp;
        line.ivaOr = response.iva;
        line.iva = line.iva === -1 ? response.iva : line.iva;
        line.stock = response.sinControlStock ? "" : response.stock;
        line.dtoMax = response.dtoMaximo;
        line.checkStock = response.sinControlStock;
        line.provider = response.proveedorNombre;
        line.providerId = response.proveedorId;
        line.commision = response.comision;
        line.ivaBought = response.ivaCompra;
        line.lastPurchaseBruto = response.precioBrutoUltimaCompra;
        line.lastPurchaseNeto = response.precioNetoUltimaCompra;
      } else {
        const response = await post("ListarTiposIVA.php", {
          token: userData.token,
          idOptica: selectedOptic.id,
        });
        if (response.tiposIVA && response.tiposIVA.length > 0) {
          line.iva = Math.max(...response.tiposIVA);
        }
      }
      return line;
    };

    const addCartToSale = async () => {
      let ventaN = structuredClone(venta);
      for (let c = 0; c < cartPopup.length; c++) {
        const cart = cartPopup[c];
        if (cart.selected) {
          for (let i = 0; i < cart.lines.length; i++) {
            const line = cart.lines[i];

            let l = structuredClone(newSaleLine);
            l.id = line.id;

            l.code = line.code;
            l.description = line.description;
            l.pvp = line.pvp;
            l.dto = line.dto;
            l.iva = line.iva;
            l.pvu = line.pvu;
            l.uds = line.uds;
            l.total = line.total;
            l.cardId = line.cardId;
            l.cardType = cart.cardType;
            l = await completeLine(l);

            cart.lines[i] = l;
          }
          ventaN.carts.push(cart);
        }
      }

      ventaN = updateVentasTotal(ventaN);
      setVenta(ventaN);
      setVentaLinesTable(createVentaLinesTable(ventaN));
      setCartPopup(null);
    };

    const showPopupCart = (show) => {
      if (show) {
        loadCarts();
      } else {
        setCartPopup(false);
      }
    };

    const showNifTypePopup = (show, target = "venta") => {
      setNifTypePopupTarget(target);
      setNifTypePopup(show);
    };

    const acceptNifTypePopup = (docType) => {
      if (nifTypePopupTarget === "invoice") {
        const invoiceN = structuredClone(invoice);
        invoiceN.nifType = docType.idNif;
        invoiceN.tipoDocumento = docType.documentId;
        setInvoice(invoiceN);
      } else {
        const ventaN = structuredClone(venta);
        ventaN.nifType = docType.idNif;
        ventaN.tipoDocumento = docType.documentId;
        setVenta(ventaN);
      }
      setNifTypePopup(false);
    };

    const showCrossSellingPopup = (show) => {
      if (show) {
        const crossSelling = structuredClone(payment.crossSelling);
        let agent = agents.find((item) => {
          return item.id === payment.crossSelling.sale.agent;
        });
        if (!agent) {
          agent = agents.find((item) => {
            return item.id === userData.id;
          });
        }
        if (agent) {
          setFilterCrossSellingAgent(agent);
          crossSelling.agent = agent.id;
        }

        setCrossSellingPopup(crossSelling);
      } else {
        setCrossSellingPopup(null);
      }
    };

    const onChangeCrossSellingNOperation = (e) => {
      const crossSelling = structuredClone(crossSellingPopup);
      crossSelling.nOperation = e;
      setCrossSellingPopup(crossSelling);
    };

    const assignCrossSelling = () => {
      if (crossSellingPopup.sale.date === "") {
        createPopupQuestion(
          "Debe asignar una compra.",
          () => removePopupQuestion(),
          null,
          "Cerrar",
        );
        return;
      }

      if (crossSellingPopup.type.id === tiposCrossSelling[0].id) {
        createPopupQuestion(
          "Debe asignar un tipo de cross selling.",
          () => removePopupQuestion(),
          null,
          "Cerrar",
        );
        return;
      }

      const paymentN = structuredClone(payment);
      paymentN.crossSelling = structuredClone(crossSellingPopup);
      setPayment(paymentN);

      const ventaN = structuredClone(venta);
      ventaN.crossSelling = structuredClone(crossSellingPopup);
      setVenta(ventaN);

      setCrossSellingPopup(null);
    };

    const removeCrossSelling = () => {
      const paymentN = structuredClone(payment);
      paymentN.crossSelling = structuredClone(newCrossSelling);
      paymentN.crossSelling.sale.agent = userData.id;
      paymentN.crossSelling.type = tiposCrossSelling[0].id;

      const ventaN = structuredClone(venta);
      ventaN.crossSelling = null;
      setVenta(ventaN);

      setPayment(paymentN);
    };

    const loadVentaCrossSelling = async () => {
      const crossSellingN = structuredClone(newCrossSelling);
      crossSellingN.type = crossSellingPopup.type;
      crossSellingN.agent = crossSellingPopup.agent;

      const response = await rpost("ventas/ObtenerVenta.php", {
        token: userData.token,
        idOptica: selectedOptic.id,
        idVenta: "",
        nOperacion: crossSellingPopup.nOperation,
      });

      if (response.idVenta) {
        crossSellingN.nOperation = crossSellingPopup.nOperation;
        crossSellingN.sale.date = "21/06/2025";
        crossSellingN.sale.agent = response.empleado;
        crossSellingN.sale.patient =
          response.codigo_cliente_venta +
          " - " +
          response.nombre_cliente_venta +
          " " +
          response.apellidos_cliente_venta;
        crossSellingN.sale.lines = response.lineas.map((line, index) => {
          return {
            id: index,
            description: line.descripcion,
            total: formatCurrency(line.total),
          };
        });
        crossSellingN.sale.total = formatCurrency(response.total_venta_neto);
        const totalPaid = response.pagos.reduce((acc, curr) => {
          return acc + curr.abono;
        }, 0);
        crossSellingN.sale.delivered = formatCurrency(totalPaid);
        crossSellingN.sale.remaining = formatCurrency(
          response.total_venta_neto - totalPaid,
        );
      }

      setCrossSellingPopup(crossSellingN);
    };

    const onChangeFilterCrossSellingType = (e) => {
      const crossSelling = structuredClone(crossSellingPopup);
      crossSelling.type = e.id;
      setCrossSellingPopup(crossSelling);
    };

    const onChangeFilterCrossSellingAgent = (e) => {
      if (e.id != userData.id && e.text !== "") {
        setPinPopup(true);
        setPinPopupAgentId(e.id);
        setPinPopupAgentName(e.text);
        setPinPopupOnAccept(() => onAcceptPinPopupCrossSelling);
        setPinPopupOnCancel(() => onCancelPinPopupCrossSelling);
      } else {
        const crossSelling = structuredClone(crossSellingPopup);
        crossSelling.agent = e.id;
        setCrossSellingPopup(crossSelling);
        setFilterCrossSellingAgent(e);
      }
    };

    const onCancelPinPopupCrossSelling = () => {
      const agent = agents.find((a) => {
        return a.id == filterCrossSellingAgente.id;
      });
      if (agent) {
        setFilterCrossSellingAgent(agents[0]);
        setTimeout(() => setFilterCrossSellingAgent(agent), 100);
      }
      setPinPopup(false);
    };

    const onAcceptPinPopupCrossSelling = (id) => {
      const agent = agents.find((a) => {
        return a.id == id;
      });
      if (agent) {
        const crossSelling = structuredClone(crossSellingPopup);
        crossSelling.agent = id;
        setCrossSellingPopup(crossSelling);
        setFilterCrossSellingAgent(agent);
      }
      setPinPopup(false);
    };

    const loadScreen = async () => {
      loadAgents();
      loadCampaigns();
      loadCardTypes();
      loadTiposIVA();
      loadPaymentMethods();
      loadTiposCrossSelling();
      loadMotivosAnulacion();
      loadLoyaltyConfig();
    };

    const openPago = () => {
      let paymentN = null;

      // El check "Enviar por E-Mail" parte del formato de ticket por defecto
      // configurado en la óptica.
      const receiptEmail = opticConfig.formatoTicketPorDefecto === "Email";

      let loyaltyPointsGeneratedN = 0;
      let loyaltyPointsGeneratedValueN = 0;
      setLoyaltyPointsApplied(0);
      setLoyaltyPointsAppliedValue(0);

      // Se filtra siempre sobre la lista completa para que EFECTIVO vuelva a
      // aparecer si la venta actual no supera el límite.
      const paymentMethodsN = paymentMethods.filter(
        (item) =>
          venta.total < MAX_IMPORTE_EFECTIVO || item.text !== "EFECTIVO",
      );

      if (saleId === -1 || rectifyingInvoiceId !== -1) {
        if (saleId === -1) {
          // Compra normal
          paymentN = {
            id: -1,
            paymentMethod: paymentMethodsN[0],
            cardType: cardTypes[0],
            cashVoucher: null,
            soldBy: filterRealizadoPor,
            deliveredBy: filterEntregadoPor,
            total: venta.total,
            totalOr: venta.total,
            delivered: venta.total,
            change: 0,
            paid: 0,
            pending: 0,
            receiptTicket: false,
            receiptA4: false,
            receiptEmail,
            crossSelling: structuredClone(newCrossSelling),
          };

          paymentN.crossSelling.sale.agent = userData.id;
          paymentN.crossSelling.type = tiposCrossSelling[0].id;

          const p = calculatePointsGenerated(venta, loyaltyConfig);
          loyaltyPointsGeneratedN = p.pointsGenerated;
          loyaltyPointsGeneratedValueN = p.pointsGeneratedValue;
          setLoyaltyPointsGenerated(loyaltyPointsGeneratedN);
          setLoyaltyPointsGeneratedValue(loyaltyPointsGeneratedValueN);
        } else {
          // Compra rectificada

          const total = venta.total - rectifyingInvoiceTotalPaid;

          paymentN = {
            id: -1,
            paymentMethod: paymentMethodsN[0],
            cardType: cardTypes[0],
            cashVoucher: null,
            soldBy: filterRealizadoPor,
            deliveredBy: filterEntregadoPor,
            total: total,
            totalOr: total,
            delivered: total,
            change: 0,
            paid: 0,
            pending: 0,
            receiptTicket: true,
            receiptA4: false,
            receiptEmail,
            crossSelling: structuredClone(newCrossSelling),
          };

          paymentN.crossSelling.sale.agent = userData.id;
          paymentN.crossSelling.type = tiposCrossSelling[0].id;
        }
      } else {
        const agent = agents.find((item) => {
          return item.id === userData.id;
        });

        paymentN = {
          id: -1,
          paymentMethod: paymentMethodsN[0],
          cardType: cardTypes[0],
          cashVoucher: null,
          soldBy: agent,
          deliveredBy: agent,
          total: venta.totalRemaining,
          totalOr: venta.totalRemaining,
          delivered: venta.totalRemaining,
          change: 0,
          paid: 0,
          pending: 0,
          receiptTicket: false,
          receiptA4: false,
          receiptEmail,
          crossSelling: structuredClone(newCrossSelling),
        };
      }
      setPaymentPopupMethods(paymentMethodsN);
      setPayment(paymentN);
      setTimeout(() => {
        const el = document.querySelector("#p-sale-delivered");
        if (el) {
          el.focus();
          setTimeout(() => {
            el.select();
          }, 1);
        }
      });
    };

    const calculatePayment = (paym) => {
      if (paym.delivered >= paym.total) {
        // Pago completo
        paym.change = paym.delivered - paym.total;
        paym.pending = 0;
        paym.paid = paym.total;
      } else {
        // Pago incompleto
        paym.change = 0;
        paym.pending = paym.total - paym.delivered;
        paym.paid = paym.delivered;
      }
      return paym;
    };

    const onChangeDelivered = (e) => {
      let paymentN = structuredClone(payment);
      paymentN.delivered = parseFloat(e.replace(",", "."));
      paymentN = calculatePayment(paymentN);
      setPayment(paymentN);
    };

    const closeVenta = () => {
      setPayment(null);
    };

    const acceptVentaStep1 = () => {
      if (rectifyingInvoiceId !== -1 && rectificationReason.trim() === "") {
        createPopupQuestion(
          "Debe introducir un motivo de rectificación.",
          () => {
            removePopupQuestion();
            setTimeout(() => {
              const el = document.getElementById("rectificacion-motivo");
              if (el) {
                el.focus();
              }
            }, 1);
          },
          null,
          "Entendido",
        );

        return;
      }

      if (rectifyingInvoiceId === -1 && filterDescription.text === "") {
        createPopupQuestion(
          "Debes indicar una descripción de venta.",
          removePopupQuestion,
          null,
          "Entendido",
        );

        return;
      }

      const lines = getValidLines(true);

      if (lines.length === 0) {
        // No products

        createPopupQuestion(
          "Debe insertar productos en la venta.",
          removePopupQuestion,
          null,
          "Cerrar",
        );

        return;
      }

      const found = lines.some((line) => line.description.trim() === "");
      if (found) {
        // Product with no description

        createPopupQuestion(
          "Debe rellenar la descripción de todas las líneas de venta.",
          removePopupQuestion,
          null,
          "Cerrar",
        );

        return;
      }

      const missingExemption = lines.some(
        (line) =>
          isExemptionEnabled(line.iva) && (line.exencionCodigo ?? "") === "",
      );
      if (missingExemption) {
        // Línea con IVA 0 sin motivo de exención

        createPopupQuestion(
          "Debes introducir un motivo de exención de IVA.",
          removePopupQuestion,
          null,
          "Entendido",
        );

        return;
      }

      if (venta.total === 0) {
        // Sale is 0 €

        createPopupQuestion(
          "La venta tiene un total de 0 €. ¿Desea continuar?.",
          () => {
            removePopupQuestion();
            acceptVentaStep2(lines);
          },
          () => {
            removePopupQuestion();
          },
          "Continuar",
          "Cancelar",
        );

        return;
      }

      acceptVentaStep2(lines);
    };

    const acceptVentaStep2 = (lines) => {
      const requiresFullInvoice =
        facturaCompleta ||
        (rectifyingInvoiceId !== -1 && rectificationType === "completa");

      if (
        requiresFullInvoice &&
        (venta.factName.trim() === "" ||
          venta.factNif.trim() === "" ||
          venta.factAddress.trim() === "" ||
          venta.factCity.trim() === "" ||
          venta.factProvince.trim() === "" ||
          venta.factPostalCode.trim() === "")
      ) {
        // Incomplete invoice info

        createPopupQuestion(
          "Debe rellenar los datos de facturación.",
          () => {
            removePopupQuestion();
            showInvoicePopup(true);
          },
          null,
          "Cerrar",
        );

        setShowFactData(true);

        return;
      }

      const found =
        opticConfig.controlSanitario &&
        lines.some((line) => {
          let f = false;
          if (line.code.length > 0) {
            const family = getFamilyFromOPTIWINCode(line.code);
            if (HEALTH_CONTROL_FAMILIES.includes(family)) {
              f = true;
            }
          }
          return f;
        });
      if (found) {
        // Health control

        openHealthControlPopup(true);

        return;
      }

      acceptVentaStep3();
    };

    const acceptVentaStep3 = () => {
      if (saleId === -1) {
        // Venta normal
        openPago();
      }
      if (rectifyingInvoiceId !== -1) {
        if (venta.total >= venta.totalPaid) {
          // Rectificación con importe mayor (realizar pago)
          setRectifyingInvoicePositive(true);
          openPago();
        } else {
          // Rectificación con importe menor (realizar devolución)
          const agent = agents.find((a) => {
            return a.id === userData.id;
          });

          const cancellationPopupN = {
            price: venta.totalPaid - venta.total,
            cancellationWay: "Original",
            sellingPaymentMethod: "",
            paymentMethod: paymentMethods[0],
            cardType: cardTypes[0],
            reason: motivosAnulacion[0],
            agent,
          };

          const uniqueMethods = venta.payments.reduce((acc, payment) => {
            if (!acc.includes(payment.method)) {
              acc.push(payment.method);
            }
            return acc;
          }, []);

          cancellationPopupN.sellingPaymentMethod = uniqueMethods.join(", ");

          setRectifyingInvoicePositive(false);
          setCancellationPopup(cancellationPopupN);
        }
      }
    };

    const showPopupCPDialog = (show, address, city, type) => {
      setCPPopupAddress(address);
      setCPPopupCity(city);
      setCPPopupType(type);
      setShowPopupCP(show);
    };

    const onAcceptCP = (fullAddress) => {
      if (cpPopupType === "personal") {
        const addressN = structuredClone(address);
        addressN.postalCode = fullAddress.postalCode;
        setAddress(addressN);
      } else {
        const invoiceN = structuredClone(invoice);
        invoiceN.postalCode = fullAddress.postalCode;
        setInvoice(invoiceN);
      }
      showPopupCPDialog(false, "", "", "personal");
    };

    const openHealthControlPopup = (show) => {
      if (show) {
        let counter = 0;
        const linesN = getValidLines(true);
        const lines = linesN.reduce((acc, curr) => {
          const family = getFamilyFromOPTIWINCode(curr.code);
          if (HEALTH_CONTROL_FAMILIES.includes(family)) {
            if (!curr.healthControl) {
              curr.healthControl = {
                date: "",
                code: curr.code,
                description: "",
                deliveryNote: "",
                shippingNumber: "",
                lotNumber: "",
              };
            }
            acc.push({
              id: counter,
              line: curr,
            });
            counter++;
          }
          return acc;
        }, []);

        setHeathControlPopupItems(lines);
        setShowHealthControlPopup(true);
      }
    };

    const acceptHealthControl = (list) => {
      list.forEach((item) => {
        const line = healthControlPopupItems.find((line) => {
          return line.id === item.idDatoSanitario;
        });
        if (line) {
          line.line.healthControl.date = item.fechaCompra;
          line.line.healthControl.description = item.descripcion;
          line.line.healthControl.deliveryNote = item.nAlbaran;
          line.line.healthControl.shippingNumber = item.nExpedicion;
          line.line.healthControl.lotNumber = item.nLote;
        }
      });

      const ventaN = structuredClone(venta);
      setVenta(ventaN);
      setShowHealthControlPopup(false);

      acceptVentaStep3();
    };

    const consumptCashVoucherPayment = (idVenta) => {
      if (payment.cashVoucher) {
        // Canjear vales de caja

        post("support/ValesCaja/CanjearValeCaja.php", {
          token: userData.token,
          idValeCaja: payment.cashVoucher.id,
          numeroTicket: idVenta,
        });

        if (venta.total < payment.cashVoucher.value) {
          // Ha sobrado dinero del vale de caja, crear uno nuevo con la diferencia

          const diff = payment.cashVoucher.value - venta.total;

          post("support/ValesCaja/InsertarValeCaja.php", {
            token: userData.token,
            idCliente: venta.idPaciente,
            importe: diff,
          });
        }
      }
    };

    const finishSaleCreation = (idVenta) => {
      setPayment(null);
      setCancellationPopup(null);
      setRectifyingInvoiceId(-1);
      setRectifyingInvoiceTotalPaid(0);
      onClickMenuOption("venta", { saleId: idVenta });
    };

    const saveSale = async () => {
      if (rectifyingInvoiceId !== -1 && rectificationReason.trim() === "") {
        createPopupQuestion(
          "Debe introducir un motivo de rectficación",
          () => {
            removePopupQuestion();
            setTimeout(() => {
              const el = document.getElementById("rectificacion-motivo");
              if (el) {
                el.focus();
              }
            }, 1);
          },
          null,
          "Entendido",
        );
        return;
      }

      if (
        rectifyingInvoiceId === -1 &&
        payment &&
        payment.receiptEmail &&
        !payment.receiptTicket &&
        !payment.receiptA4
      ) {
        createPopupQuestion(
          "Debes seleccionar un tipo de documento (ticket o A4).",
          () => {
            removePopupQuestion();
          },
          null,
          "Entendido",
        );
        return;
      }

      const empleado = agents.find((agent) => agent.id === venta.soldBy);

      const motivo = campaigns.find(
        (campaign) => campaign.id === venta.campaign,
      );

      const entregado = payment
        ? agents.find((agent) => agent.id === payment.deliveredBy.id)
        : agents.find((agent) => agent.id === userData.id);

      const applyLoyaltyPoints = rectifyingInvoiceId === -1 && loyaltyId !== "";

      let linesF = getValidLines(true);

      if (applyLoyaltyPoints && loyaltyPointsApplied > 0) {
        // Calcular descuento por puntos y aplicar a todas las líneas,
        // igual que al ajustar el total manualmente (ver onBlurTotal)

        const linesN = linesF.map((line) => {
          return {
            id: line.code === "" ? line.description : line.code,
            total: line.total,
            dto: parseFloat(line.dto) || 0,
            dtoMax: line.code === "" ? "" : line.dtoMax,
          };
        });

        const result = calculateDtos(linesN, payment.total, false);

        if (result.error === "") {
          linesF.forEach((line, i) => {
            line.dto = result.lines[i].dto;
            line.total = result.lines[i].total;
            line.pvu = line.total / line.uds;
          });
        }
      }

      let totalCompraBruto = "";
      let totalCompraNeto = "";
      let totalBeneficioBruto = "";
      let totalBeneficioNeto = "";
      let totalPorcBeneficioBruto = "";
      let totalPorcBeneficioNeto = "";

      const lines = linesF.map((line) => {
        const pvpBruto = line.pvp;
        const pvpNeto = line.pvp - (line.pvp * line.dto) / 100;
        const dto = pvpBruto - pvpNeto;
        const pvpBrutoConIva = pvpBruto;
        const pvpBrutoSinIva = pvpBruto / (1 + line.iva / 100);
        const PvpNetoConIva = pvpNeto;
        const PvpNetoSinIva = pvpNeto / (1 + line.iva / 100);
        const dtoConIva = dto;
        const dtoSinIva = dto / (1 + line.iva / 100);
        const iva = PvpNetoConIva - PvpNetoSinIva;

        let compraBruto = "";
        let compraNeto = "";
        let beneficioBruto = "";
        let beneficioNeto = "";
        let porcBeneficioBruto = "";
        let porcBeneficioNeto = "";

        if (line.lastPurchaseBruto !== "") {
          compraBruto = line.lastPurchaseBruto * line.uds;
          compraNeto = line.lastPurchaseNeto * line.uds;
          beneficioBruto = pvpBruto * line.uds - compraBruto;
          beneficioNeto = pvpNeto * line.uds - compraNeto;
          porcBeneficioBruto = (beneficioBruto / compraBruto) * 100;
          porcBeneficioNeto = (beneficioNeto / compraNeto) * 100;

          if (totalCompraBruto === "") {
            totalCompraBruto = compraBruto;
            totalCompraNeto = compraNeto;
            totalBeneficioBruto = beneficioBruto;
            totalBeneficioNeto = beneficioNeto;
          } else {
            totalCompraBruto += compraBruto;
            totalCompraNeto += compraNeto;
            totalBeneficioBruto += beneficioBruto;
            totalBeneficioNeto += beneficioNeto;
          }
        }

        let healthControl = -1;
        if (line.healthControl) {
          healthControl = {
            albaran: line.healthControl.deliveryNote,
            expedicion: line.healthControl.shippingNumber,
            lote: line.healthControl.lotNumber,
            fecha: line.healthControl.date,
            descripcion: line.healthControl.description,
          };
        }

        return {
          codigo: line.code,
          proveedor: line.provider,
          idProveedor: line.providerId,
          descripcion: line.description,
          pvp_bruto_siniva: pvpBrutoSinIva,
          pvp_bruto_coniva: pvpBrutoConIva,
          dto: line.dto,
          dto_siniva: dtoSinIva,
          dto_coniva: dtoConIva,
          pvp_neto_siniva: PvpNetoSinIva,
          pvp_neto_coniva: PvpNetoConIva,
          cantidad: line.uds,
          base: PvpNetoSinIva,
          tipo_iva: parseInt(line.iva),
          iva,
          total: line.total,
          pvp_especial: line.pvpSpecial,
          cantidad_especial: line.specialUds,
          pvp_original: line.pvpOr,
          comision: line.commision,
          importe_comision: (line.total * line.commision) / 100,
          id_ficha: line.cardId,
          numero_encargo: -1,
          numero_presupuesto: -1,
          numero_proforma: -1,
          tipo_ficha: line.cardId === -1 ? "T" : line.cardType[0].toUpperCase(),
          tipo_iva_compra: line.ivaBought,
          tipo_iva_venta: line.iva,
          exencionCodigo: line.exencionCodigo ?? "",
          exencionDescripcion: line.exencionDescripcion ?? "",
          controlSanitario: healthControl,
          precioBrutoCompra: compraBruto,
          precioNetoCompra: compraNeto,
          beneficioBruto,
          beneficioNeto,
          porcBrutoCompra: porcBeneficioBruto,
          porcNetoCompra: porcBeneficioNeto,
          numero_encargo: venta.orderNumber,
          numero_presupuesto: venta.quoteNumber,
          numero_proforma: venta.proformaNumber,
        };
      });

      if (totalCompraBruto !== "") {
        totalPorcBeneficioBruto =
          (totalBeneficioBruto / totalCompraBruto) * 100;
        totalPorcBeneficioNeto = (totalBeneficioNeto / totalCompraNeto) * 100;
      }

      const ivas = venta.ivas.map((item) => {
        const linesF = lines.filter((line) => line.tipo_iva === item.percIva);

        let brutoTotal = 0;
        let netoTotal = 0;
        linesF.forEach((line) => {
          brutoTotal = brutoTotal + line.pvp_bruto_coniva;
          netoTotal = netoTotal + line.pvp_neto_coniva;
        });
        const dtoTotal = brutoTotal - netoTotal;
        const dto = (dtoTotal / brutoTotal) * 100;

        return {
          tipo: item.percIva,
          suma: linesF.length,
          dto,
          total_dto: dtoTotal,
          base: item.base,
          iva: item.iva,
          total: item.total,
        };
      });

      let pago = null;
      if (rectifyingInvoiceId === -1) {
        // Pago normal
        pago = {
          abono: payment.paid,
          formaPago: payment.paymentMethod.text,
          tipoTarjeta: payment.cardType.text,
          empleado: payment.soldBy.text,
        };
      } else {
        if (rectifyingInvoicePositive) {
          // Pago por rectificación de factura
          pago = {
            abono: payment.paid + rectifyingInvoiceTotalPaid,
            formaPago: payment.paymentMethod.text,
            tipoTarjeta: payment.cardType.text,
            empleado: payment.soldBy.text,
          };
        } else {
          // Abono por rectificación de factura. La devolución que se muestra
          // es la diferencia (cancellationPopup.price), pero el abono que se
          // envía es el total de la nueva venta rectificada, igual que en la
          // rectificación al alza (pagado + lo ya abonado).
          pago = {
            abono: venta.total,
            formaPago: cancellationPopup.paymentMethod.text,
            tipoTarjeta: cancellationPopup.cardType.text,
            empleado: cancellationPopup.agent.text,
          };
        }
      }

      let totalVentaBruto = venta.total + venta.totalDto;
      let totalVentaNeto = 0;
      let totalDtoEuros = 0;
      if (applyLoyaltyPoints && loyaltyPointsApplied > 0) {
        totalVentaNeto = payment.total;
        totalDtoEuros = payment.totalOr - payment.total;
      } else {
        totalVentaNeto = venta.total;
        totalDtoEuros = venta.totalDto;
      }

      const descuentoGeneral = parseInt(
        (1 - totalVentaNeto / totalVentaBruto) * 100,
      );

      const sale = {
        token: userData.token,
        idVenta: -1,
        idVentaRectificada: rectifyingInvoiceId,
        motivoRectificacion: rectificationReason,
        tipo_rectificacion:
          rectificationType === "simple" ? "Simple" : "Completa",
        idOptica: selectedOptic.id,
        idCliente: venta.idPaciente,
        numero_cliente_venta: venta.codPaciente,
        nombre_cliente_venta: venta.name,
        apellidos_cliente_venta: venta.lastName,
        nif_cliente_venta: venta.nif,
        tipoDocumento_nif_cliente_venta: venta.nifType,
        direccion_venta: venta.address,
        codigo_postal_venta: venta.postalCode,
        localidad_venta: venta.city,
        provincia_venta: venta.province,
        telefono_venta: venta.phone,
        generar_factura_completa: facturaCompleta,
        numero_cliente_factura: venta.factCodPaciente,
        nombre_cliente_factura: venta.factName,
        apellidos_cliente_factura: "",
        nif_cliente_factura: venta.factNif,
        tipoDocumento_nif_cliente_factura: venta.factNifType,
        direccion_factura: venta.factAddress,
        codigo_postal_factura: venta.factPostalCode,
        localidad_factura: venta.factCity,
        provincia_factura: venta.factProvince,
        empleado: empleado.text,
        motivo_agente: motivo.text,
        entregado_por: entregado.text,
        total_venta_bruto: totalVentaBruto,
        descuento_general: descuentoGeneral,
        total_dto_euros: totalDtoEuros,
        total_venta_neto: totalVentaNeto,
        pagado: payment ? payment.pending === 0 : true, // En caso contrario es la devolución por rectificación de factura
        cross_selling: venta.crossSelling != null,
        tipo_cross_selling: venta.crossSelling ? payment.crossSelling.type : "",
        venta_origen_cross_selling: venta.crossSelling
          ? payment.crossSelling.nOperation
          : "",
        tipo_ficha_cross_selling: "",
        empleado_cross_selling: venta.crossSelling
          ? payment.crossSelling.agent
          : "",
        lineas: lines,
        ivas,
        pago,
        entregado: payment ? payment.delivered : 0,
        cambio: payment ? payment.change : 0,
        observaciones: venta.observations,
        descripcion: filterDescription.text,
        totalCompraBruto,
        totalCompraNeto,
        totalBeneficioBruto,
        totalBeneficioNeto,
        porcBeneficioBruto: totalPorcBeneficioBruto,
        porcBeneficioNeto: totalPorcBeneficioNeto,
      };

      setSavingPayment(true);

      const response =
        rectifyingInvoiceId !== -1
          ? await rpost("ventas/GenerarFacturaRectificativa.php", sale)
          : await rpost("ventas/GuardarVenta.php", sale);

      if (response.error !== "") {
        // Error al finalizar compra

        setSavingPayment(false);
        createPopupQuestion(
          response.error,
          () => removePopupQuestion(),
          null,
          "Cerrar",
        );
      } else {
        // Compra OK

        const idVenta = response.idVenta;
        const nOperacion = response.nOperacion;

        if (payment) {
          // No aplicar en caso de que sea la devolución por una compra rectificativa, la cual no tiene payment (el canjeo se procesa en el popup de devolución)
          consumptCashVoucherPayment(idVenta);
        }

        if (applyLoyaltyPoints && opticConfig.idFidelizacion !== "") {
          // Actualización de puntos en la compra y generación de movimiento

          await post("ActualizarPuntosCompra.php", {
            token: userData.token,
            idFidelizacion: loyaltyId,
            totalPuntos: loyaltyPoints,
            idOptica: selectedOptic.id,
            idCompra: idVenta,
            puntosCanjeados: loyaltyPointsApplied,
            puntosCanjeadosValor: loyaltyPointsAppliedValue,
            puntosGenerados: loyaltyPointsGenerated,
            puntosGeneradosValor: loyaltyPointsGeneratedValue,
          });

          if (loyaltyPointsApplied > 0) {
            await spost("Fidelizacion/GenerarMovimiento.php", {
              token: userData.token,
              idCliente: venta.idPaciente,
              idFidelizacion: loyaltyId,
              numeroTicket: nOperacion,
              opticaGestion: selectedOptic.id,
              empleado: empleado.text,
              tipoMovimiento: "PCV",
              descripcion: "",
              puntos: -loyaltyPointsApplied,
              totalPuntos: loyaltyPoints,
            });
          }

          if (payment ? payment.pending === 0 : true) {
            // Si está pagada entonces generar puntos por la compra

            await applyGeneratedPoints(
              venta.idPaciente,
              nOperacion,
              empleado.text,
              loyaltyPoints - loyaltyPointsApplied,
            );
          }
        }

        const receiptFormats = [];
        if (rectifyingInvoiceId === -1 && payment) {
          if (payment.receiptTicket) receiptFormats.push("imp-ticket");
          if (payment.receiptA4) receiptFormats.push("imp-factura");
        }

        if (receiptFormats.length === 0) {
          finishSaleCreation(response.idVenta);
        } else if (!payment.receiptEmail) {
          for (const invoiceType of receiptFormats) {
            await printInvoiceDirect({
              idVenta: response.idVenta,
              invoiceType,
              printObservations: false,
              printPayments: false,
              opticConfig,
              createPopupQuestion,
              removePopupQuestion,
            });
          }
          finishSaleCreation(response.idVenta);
        } else {
          const adjuntos = [];
          for (const invoiceType of receiptFormats) {
            const doc = await printInvoice({
              idVenta: response.idVenta,
              invoiceType,
              printObservations: false,
              printPayments: false,
              createPopupQuestion,
              removePopupQuestion,
            });
            if (doc) {
              adjuntos.push({
                titulo: doc.nombreFichero,
                fichero: doc.fichero,
              });
            }
          }

          let email = "";
          if (venta.idPaciente && venta.idPaciente !== -1) {
            const patientResponse = await post("ObtenerDatosPaciente.php", {
              token: userData.token,
              optica: selectedOptic.id,
              idPaciente: venta.idPaciente,
            });
            email = patientResponse?.email ?? "";
          }

          setEmailAttachments(adjuntos);
          setEmailDestinatario(email);
          setEmailAsunto("INFORMACIÓN DE LA VENTA");
          setPaymentEmailIdVenta(response.idVenta);
          setShowEmailPopup(true);
        }
      }
    };

    const onGoToScreen = (screen, params) => {
      const validLines = getValidLines(true);

      if (
        (saleId !== -1 && rectifyingInvoiceId === -1) ||
        JSON.stringify(venta) === JSON.stringify(emptySale)
      ) {
        onClickMenuOption(screen, params);
      } else {
        createPopupQuestion(
          rectifyingInvoiceId === -1 || !createdSale
            ? "Existe una nueva venta en proceso. ¿Desea abandonarla?"
            : "Existe una rectificación de factura en proceso. ¿Desea abandonarla?",
          () => {
            if (screen === "venta") {
              if (rectifyingInvoiceId === -1) {
                if (orderPatientId !== -1) {
                  onClickMenuOption("ventas");
                  setTimeout(
                    () => onClickMenuOption("venta", { saleId: -1 }),
                    100,
                  );
                } else {
                  loadVenta();
                }
              } else {
                setRectifyingInvoiceId(-1);
                setRectifyingInvoiceTotalPaid(0);
                onClickMenuOption("venta", { saleId: -1 });
              }
            } else {
              onClickMenuOption(screen, params);
            }
            removePopupQuestion();
          },
          () => {
            removePopupQuestion();
          },
          "Salir",
          "Cancelar",
        );
      }
    };

    const performPayment = async () => {
      if (rectifyingInvoiceId !== -1) {
        // Rectificación de factura
        await saveSale();
      } else {
        // Pago de compra normal
        setSavingPayment(true);
        await rpost("ventas/RealizarPago.php", {
          token: userData.token,
          idVenta: saleId,
          abono: payment.paid,
          formaPago: payment.paymentMethod.text,
          tipoTarjeta: payment.cardType.text,
          empleado: payment.soldBy.text,
          pagado: payment.pending === 0,
          entregado: payment.delivered,
          cambio: payment.change,
        });

        consumptCashVoucherPayment(saleId);

        const opticConfigN = await loadOpticConfig();

        if (
          payment.pending === 0 &&
          loyaltyId !== "" &&
          opticConfigN.idFidelizacion !== ""
        ) {
          // Asignar puntos de fidelización si la venta ha quedado pagada

          const res = await post("ObtenerPuntosValorPaciente.php", {
            token: userData.token,
            idOptica: selectedOptic.id,
            idCliente: venta.idPaciente,
          });
          const patientPoints = res.points;

          applyGeneratedPoints(
            venta.idPaciente,
            venta.nOperation,
            payment.soldBy.text,
            patientPoints,
          );
        }

        setPayment(null);
        loadVenta();
      }
    };

    const cancelSell = async () => {
      if (cancellationPopup.cancellationWay === "Original") {
        // Comprobar si en la formas de pago hay vales de caja, para generarlos de nuevo
        for (let i = 0; i < venta.payments.length; i++) {
          const payment = venta.payments[i];
          if (payment.method === "VALE DE CAJA") {
            post("support/ValesCaja/InsertarValeCaja.php", {
              token: userData.token,
              idCliente: venta.idPaciente,
              importe: payment.paid,
            });
          }
        }
      } else {
        if (cancellationPopup.paymentMethod.text === "VALE DE CAJA") {
          // Generar un único vale de caja

          post("support/ValesCaja/InsertarValeCaja.php", {
            token: userData.token,
            idCliente: venta.idPaciente,
            importe: cancellationPopup.price,
          });
        }
      }

      if (rectifyingInvoiceId !== -1) {
        // Devolución por rectificación de factura
        saveSale();
      } else {
        // Abono normal
        await rpost("ventas/AnularVenta.php", {
          token: userData.token,
          idVenta: saleId,
          idOptica: selectedOptic.id,
          empleado: cancellationPopup.agent.text,
          tipoPago: cancellationPopup.cancellationWay,
          formaPago: cancellationPopup.paymentMethod.text,
          tipoTarjeta: cancellationPopup.cardType.text,
          motivoDevolucion: cancellationPopup.reason.text,
        });

        const opticConfigN = await loadOpticConfig();

        if (
          venta.paid &&
          loyaltyId !== "" &&
          opticConfigN.idFidelizacion !== "" &&
          loyaltyPointsGenerated > 0
        ) {
          // Restar los puntos de fidelización generados si la venta estaba ya pagada

          const res = await post("ObtenerPuntosValorPaciente.php", {
            token: userData.token,
            idOptica: selectedOptic.id,
            idCliente: venta.idPaciente,
          });
          const patientPoints = res.points;

          await spost("Fidelizacion/GenerarMovimiento.php", {
            token: userData.token,
            idCliente: venta.idPaciente,
            idFidelizacion: loyaltyId,
            numeroTicket: venta.nOperation,
            opticaGestion: selectedOptic.id,
            empleado: cancellationPopup.agent.text,
            tipoMovimiento: "PPD",
            descripcion: "",
            puntos: -loyaltyPointsGenerated,
            totalPuntos: patientPoints,
          });
        }

        if (
          loyaltyPoints > 0 &&
          loyaltyId !== "" &&
          opticConfigN.idFidelizacion !== ""
        ) {
          // Devolver lo puntos de fidelización canjeados

          const res = await post("ObtenerPuntosValorPaciente.php", {
            token: userData.token,
            idOptica: selectedOptic.id,
            idCliente: venta.idPaciente,
          });
          const patientPoints = res.points;

          await spost("Fidelizacion/GenerarMovimiento.php", {
            token: userData.token,
            idCliente: venta.idPaciente,
            idFidelizacion: loyaltyId,
            numeroTicket: venta.nOperation,
            opticaGestion: selectedOptic.id,
            empleado: cancellationPopup.agent.text,
            tipoMovimiento: "PRD",
            descripcion: "",
            puntos: loyaltyPoints,
            totalPuntos: patientPoints,
          });
        }

        setCancellationPopup(null);
        loadVenta();
      }
    };

    const showCancelPopup = (show) => {
      if (show) {
        const totalPayment = venta.payments.reduce((acc, curr) => {
          if (curr.paid >= 0) {
            acc += curr.paid;
          }
          return acc;
        }, 0);
        const agent = agents.find((a) => {
          return a.id === userData.id;
        });
        const cancellationPopupN = {
          price: totalPayment,
          cancellationWay: "Original",
          sellingPaymentMethod: "",
          paymentMethod: paymentMethods[0],
          cardType: cardTypes[0],
          reason: motivosAnulacion[0],
          agent,
        };

        const uniqueMethods = venta.payments.reduce((acc, payment) => {
          if (!acc.includes(payment.method)) {
            acc.push(payment.method);
          }
          return acc;
        }, []);

        cancellationPopupN.sellingPaymentMethod = uniqueMethods.join(", ");

        setCancellationPopup(cancellationPopupN);
      } else {
        setCancellationPopup(null);
      }
    };

    const onChangeCancellationWay = (way) => {
      const cancellationPopupN = structuredClone(cancellationPopup);
      cancellationPopupN.cancellationWay = way;
      setCancellationPopup(cancellationPopupN);
    };

    const onChangeCancellationPaymentMethod = (method) => {
      const cancellationPopupN = structuredClone(cancellationPopup);
      cancellationPopupN.paymentMethod = method;

      if (method.text !== "TARJETA") {
        const cardType = cardTypes.find((c) => c.text === "");
        if (cardType) {
          cancellationPopupN.cardType = cardType;
        }
      }

      setCancellationPopup(cancellationPopupN);
    };

    const onChangeCancellationCardType = (cardType) => {
      const cancellationPopupN = structuredClone(cancellationPopup);
      cancellationPopupN.cardType = cardType;
      setCancellationPopup(cancellationPopupN);
    };

    const onChangeCancellationReason = (reason) => {
      const cancellationPopupN = structuredClone(cancellationPopup);
      cancellationPopupN.reason = reason;
      setCancellationPopup(cancellationPopupN);
    };

    const onChangeCancellationAgent = (e) => {
      if (e.id != userData.id && e.text !== "") {
        setPinPopup(true);
        setPinPopupAgentId(e.id);
        setPinPopupAgentName(e.text);
        setPinPopupOnAccept(() => onAcceptCancellationAgent);
        setPinPopupOnCancel(() => onCancelCancellationAgent);
      } else {
        const cancellationPopupN = structuredClone(cancellationPopup);
        cancellationPopupN.agent = e;
        setCancellationPopup(cancellationPopupN);
      }
    };

    const onAcceptCancellationAgent = (id) => {
      const agent = agents.find((a) => {
        return a.id == id;
      });
      if (agent) {
        const cancellationPopupN = structuredClone(cancellationPopup);
        cancellationPopupN.agent = agent;
        setCancellationPopup(cancellationPopupN);
      }
      setPinPopup(false);
    };

    const onCancelCancellationAgent = () => {
      const agent = agents.find((a) => {
        return a.id == cancellationPopup.agent.id;
      });
      if (agent) {
        const cancellationPopupN = structuredClone(cancellationPopup);
        cancellationPopupN.agent = { id: -1, text: "" };
        setCancellationPopup(cancellationPopupN);
        setTimeout(() => {
          const cancellationPopupN = structuredClone(cancellationPopup);
          cancellationPopupN.agent = agent;
          setCancellationPopup(cancellationPopupN);
        }, 100);
      }
      setPinPopup(false);
    };

    const openGenerateInvoice = () => {
      setGeneratingInvoice(true);
      showInvoicePopup(true);
    };

    const generateInvoice = async () => {
      if (
        invoice.name.trim() === "" ||
        invoice.nif.trim() === "" ||
        invoice.address.trim() === "" ||
        invoice.city.trim() === "" ||
        invoice.province.trim() === "" ||
        invoice.postalCode.trim() === ""
      ) {
        createPopupQuestion(
          "Rellene todos los datos de facturación.",
          removePopupQuestion,
          null,
          "Cerrar",
        );
        return;
      }
      await rpost("ventas/GenerarFacturaCanje.php", {
        token: userData.token,
        idVenta: saleId,
        idOptica: selectedOptic.id,
        numero_cliente_factura: invoice.codPaciente,
        nombre_cliente_factura: invoice.name,
        apellidos_cliente_factura: "",
        nif_cliente_factura: invoice.nif,
        direccion_factura: invoice.address,
        codigo_postal_factura: invoice.postalCode,
        localidad_factura: invoice.city,
        provincia_factura: invoice.province,
      });

      setInvoice(null);
      loadVenta();
    };

    const rectifyInvoice = async () => {
      createPopupQuestion(
        "¿Está seguro de que desea rectificar la factura?",
        async () => {
          let ventaN = structuredClone(newSale);
          ventaN.idPaciente = venta.idPaciente;
          ventaN.codPaciente = venta.codPaciente;
          ventaN.name = venta.name;
          ventaN.lastName = venta.lastName;
          ventaN.address = venta.address;
          ventaN.city = venta.city;
          ventaN.province = venta.province;
          ventaN.postalCode = venta.postalCode;
          ventaN.nif = venta.nif;
          ventaN.nifType = venta.nifType;
          ventaN.tipoDocumento = venta.tipoDocumento;
          ventaN.factCodPaciente = venta.factCodPaciente;
          ventaN.factName = venta.factName;
          ventaN.factNif = venta.factNif;
          ventaN.factNifType = venta.factNifType;
          ventaN.factTipoDocumento = venta.factTipoDocumento;
          ventaN.factAddress = venta.factAddress;
          ventaN.factCity = venta.factCity;
          ventaN.factProvince = venta.factProvince;
          ventaN.factPostalCode = venta.factPostalCode;
          ventaN.factType = venta.factType;
          ventaN.phone = venta.phone;
          ventaN.status = "Venta";
          ventaN.date = moment().format("DD/MM/YYYY HH:mm:ss");
          ventaN.nOperation = "";
          ventaN.nFact = "";
          ventaN.paid = false;
          ventaN.payments = venta.payments;
          ventaN.totalPaid = venta.totalPaid;
          ventaN.soldBy = venta.soldBy;
          ventaN.deliveredBy = venta.deliveredBy;
          ventaN.campaign = venta.campaign;
          ventaN.delivered = venta.delivered;
          ventaN.patientDto = venta.patientDto;

          let n = -1;
          ventaN.lines = [];
          for (let i = 0; i < venta.lines.length; i++) {
            const l = structuredClone(venta.lines[i]);
            l.id = n;
            l.stock = "";
            l.checkStock = false;
            l.healthControl = null;
            l.cardId = -1;
            l.cardType = "";
            l.lastPurchaseBruto = "";
            l.lastPurchaseNeto = "";
            l.pvpOr = venta.lines[i].pvp;
            l.ivaOr = venta.lines[i].iva;

            if (l.code !== "") {
              const response = await post("ObtenerProducto.php", {
                token: userData.token,
                codigo: l.code,
                idOptica: selectedOptic.id,
              });
              l.lastPurchaseBruto = response.precioBrutoUltimaCompra;
              l.lastPurchaseNeto = response.precioNetoUltimaCompra;
            }

            ventaN.lines.push(l);

            n--;
          }

          setNId(n);
          ventaN = updateVentasTotal(ventaN);
          setVentaLinesTable(createVentaLinesTable(ventaN));

          setRectifyingInvoiceId(venta.id);
          loadOpticConfig();
          setRectifyingInvoiceTotalPaid(venta.totalPaid);
          setRectificationType(
            venta.factType === "Simple" ? "simple" : "completa",
          );
          setRectificationReason("");
          setVenta(ventaN);
          removePopupQuestion();

          setTimeout(() => {
            const el = document.getElementById("rectificacion-motivo");
            if (el) {
              el.focus();
            }
          }, 1);
        },
        removePopupQuestion,
        "Rectificar",
        "Cancelar",
      );
    };

    const markAsPaid = async () => {
      if (
        venta.id !== -1 &&
        !venta.paid &&
        venta.status !== "Anulada" &&
        venta.status !== "Rectificada" &&
        rectifyingInvoiceId === -1
      ) {
        createPopupQuestion(
          "¿Está seguro de que desea cancelar la deuda? La venta quedará marcada como pagada.",
          async () => {
            const agent = agents.find((a) => a.id === userData.id);

            await rpost("ventas/MarcarVentaPagada.php", {
              token: userData.token,
              idVenta: saleId,
              abono: venta.totalRemaining,
              agente: agent.text,
            });

            loadVenta();
            removePopupQuestion();
          },
          removePopupQuestion,
          "Aceptar",
          "Cancelar",
        );
      }
    };

    const deliverSale = (v) => {
      const agent = agents.find((a) => a.id === v.deliveredBy);

      rpost("ventas/MarcarVentaEntregada.php", {
        token: userData.token,
        idVenta: saleId,
        entregado: v.delivered,
        agente: agent.text,
      });

      createPopupQuestion(
        "La venta ha sido actualizada.",
        removePopupQuestion,
        null,
        "Aceptar",
      );
    };

    /*const loadCashVouchers = async (patId) => {
      let cashVouchersN = structuredClone(cashVouchersOr);
      cashVouchersN = cashVouchersN.sort((a, b) => a.value - b.value);
      setCashVouchers(cashVouchersN);
    };*/

    const onChangeLoyaltyPointsApplied = (e) => {
      setLoyaltyPointsAppliedValue(e);
      const points = calculatePointsFromValue(e, loyaltyConfig);
      setLoyaltyPointsApplied(points);
      applyLoyaltyPoints(e);
    };

    const onSubmitLoyaltyPointsApplied = () => {
      if (loyaltyPointsAppliedValue === "") {
        setLoyaltyPointsApplied(0);
        setLoyaltyPointsAppliedValue(0);
        applyLoyaltyPoints(0);
      } else {
        if (loyaltyPointsAppliedValue > loyaltyPointsValue) {
          setLoyaltyPointsApplied(loyaltyPoints);
          setLoyaltyPointsAppliedValue(loyaltyPointsValue);
          applyLoyaltyPoints(loyaltyPointsValue);
        }
      }
    };

    const applyLoyaltyPoints = (pointsValue) => {
      let totalN = payment.totalOr - pointsValue;
      if (totalN <= 0) {
        totalN = 0;
        createPopupQuestion(
          "Los puntos a canjear creará una compra con importe 0 €.",
          removePopupQuestion,
          null,
          "Cerrar",
        );
      }
      const paymentN = structuredClone(payment);
      paymentN.total = totalN;
      paymentN.paid = totalN;
      paymentN.delivered = totalN;
      setPayment(paymentN);
    };

    const applyGeneratedPoints = async (
      patientId,
      nOperation,
      agent,
      totalPoints,
    ) => {
      if (loyaltyPointsGenerated <= 0) {
        return;
      }

      await spost("Fidelizacion/GenerarMovimiento.php", {
        token: userData.token,
        idCliente: patientId,
        idFidelizacion: loyaltyId,
        numeroTicket: nOperation,
        opticaGestion: selectedOptic.id,
        empleado: agent,
        tipoMovimiento: "PGV",
        descripcion: "",
        puntos: loyaltyPointsGenerated,
        totalPuntos: totalPoints,
      });
    };

    const exportSaleReport = async (format) => {
      const titulosTabla = [
        `Cod. paciente: ${venta.codPaciente}`,
        `Nombre: ${venta.name}`,
        `Apellidos: ${venta.lastName}`,
        `Dirección: ${createAddress(venta.address, venta.city, venta.province, venta.postalCode)}`,
        `DNI / NIF: ${venta.nif} (${venta.tipoDocumento || "01"})`,
      ];

      if (venta.factName !== "") {
        titulosTabla.push(
          `Datos de facturación: ${venta.factName}, ${venta.factNif} (${venta.factTipoDocumento || "01"}), ${venta.factAddress}, ${venta.factPostalCode} ${venta.factCity} ${venta.factProvince}`,
        );
      }

      titulosTabla.push(
        `Nº operación: ${venta.nOperation}`,
        `Nº factura: ${venta.nFact}`,
        `Fecha: ${moment(venta.date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss")}`,
        `Teléfono: ${venta.phone}`,
        `Estado: ${venta.status.toUpperCase()}`,
        `Puntos canj. / gen.: ${
          loyaltyId === ""
            ? "-"
            : formatNumber(loyaltyPoints) +
              " - " +
              formatCurrency(loyaltyPointsValue) +
              " / " +
              formatNumber(loyaltyPointsGenerated) +
              " - " +
              formatCurrency(loyaltyPointsGeneratedValue)
        }`,
        `Vale caja (€): ${venta.cashVouncher}`,
        `Vendido por: ${filterRealizadoPor.text}`,
        `Entregado por: ${filterEntregadoPor.text}`,
        `Campaña: ${filterCampaign.text}`,
      );

      if (venta.observations) {
        titulosTabla.push(`Observaciones: ${venta.observations}`);
      }

      const tables = [
        {
          titulosTabla: [titulosTabla.join(", ")],
          numReferencias: "",
          extraCabeceras: [
            { titulo: "Total dto.", descripcion: totalDtoF },
            { titulo: "Total base", descripcion: totalBaseF },
            { titulo: "Total IVA", descripcion: totalIVAF },
            { titulo: "Total", descripcion: formatCurrency(venta.total) },
          ],
          cabeceras: [
            { titulo: "Codigo", tipo: "string" },
            { titulo: "Descripción del producto", tipo: "string" },
            { titulo: "PVP", tipo: "currency" },
            { titulo: "Dto", tipo: "perc" },
            { titulo: "IVA", tipo: "perc" },
            { titulo: "PVU", tipo: "currency" },
            { titulo: "Uds.", tipo: "int" },
            { titulo: "Total", tipo: "currency" },
          ],
          filas: getValidLines(true).map((line) => [
            line.code,
            line.description,
            formatCurrency(line.pvp),
            Math.round(parseFloat(line.dto) || 0) + " %",
            line.iva + " %",
            formatCurrency(line.pvu),
            line.uds,
            formatCurrency(line.total),
          ]),
        },
      ];

      await exportToFile(
        `VENTA con Nº operación ${venta.nOperation}`,
        [],
        false,
        false,
        format,
        tables,
        -1,
        "",
      );
    };

    useEffect(() => {
      if (show && !loaded) {
        loadScreen();
      }
    }, [show]);

    // El botón Guardar del popup de pago se desbloquea al abrirlo o cerrarlo
    const paymentPopupOpen = payment !== null;
    useEffect(() => {
      setSavingPayment(false);
    }, [paymentPopupOpen]);

    useEffect(() => {
      if (forceCreateNewRow) {
        createNewRow();
        setForceCreateNewRow(false);
      }
    }, [forceCreateNewRow]);

    useEffect(() => {
      if (
        show &&
        agents &&
        campaigns &&
        paymentMethods &&
        cardTypes &&
        tiposIVA &&
        tiposCrossSelling &&
        loyaltyConfig &&
        saleId &&
        !loaded
      ) {
        loadVenta();
        setLoaded(true);
      }
    }, [
      show,
      agents,
      campaigns,
      paymentMethods,
      cardTypes,
      tiposIVA,
      tiposCrossSelling,
      loyaltyConfig,
      saleId,
    ]);

    useEffect(() => {
      if (show && saleId != null && loaded) {
        loadVenta();
      }
    }, [show, saleId]);

    if (!show || venta == null) {
      return <></>;
    }

    return (
      <div className="patient-data sales-data sale-data">
        <div className="patient-data-header">
          <span className="header-text">Venta</span>
        </div>
        {loading && <LoadingScreen message="Cargando datos de venta..." />}
        {!loading && (
          <div className="patient-data-content store-data-content">
            <div className="action-bar action-bar-store">
              <div className="action-bar-resume">
                <span>TPV</span>
                <span>|</span>
                <span>Búsqueda de venta</span>
                <span>|</span>
                <span className="signed-text">Venta</span>
              </div>
            </div>
            <div
              className="store-info sales-info-header"
              style={{ display: "flex", flexDirection: "row" }}
            >
              <div className="sales-content">
                <div className="patient-search-content store-search-content">
                  <div className="general-header">
                    <div className="general-header-info">
                      <div className="screen-row screen-row-space-between screen-row-content">
                        <div className="screen-row-3">
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Cod. paciente</span>
                            </div>
                            <InputSearch
                              id="codigorec-sale"
                              size={1}
                              tabIndex={1}
                              link={true}
                              code={true}
                              op={venta.codPaciente}
                              onSelect={onSelectPatient}
                              onClickLink={onLinkPatient}
                              showCode={true}
                              disabled={
                                saleId !== -1 || rectifyingInvoiceId !== -1
                              }
                            />
                          </div>
                          <div className="screen-item">
                            <div className="screen-item">
                              <div className="cell-extra cell-extra-big-label">
                                <span className="label">Nombre</span>
                              </div>
                              <InputData
                                tabIndex={2}
                                type="type-alpha"
                                size={0}
                                input={venta.name}
                                onChange={onChangeNombre}
                                inactive={
                                  rectifyingInvoiceId === -1 && saleId !== -1
                                }
                              />
                            </div>
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Apellidos</span>
                            </div>
                            <InputData
                              tabIndex={3}
                              type="type-alpha"
                              size={0}
                              input={venta.lastName}
                              onChange={onChangeApellidos}
                              inactive={
                                rectifyingInvoiceId === -1 && saleId !== -1
                              }
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Dirección</span>
                            </div>
                            <InputData
                              tabIndex={4}
                              type="type-alpha"
                              size={0}
                              input={createAddress(
                                venta.address,
                                venta.city,
                                venta.province,
                                venta.postalCode,
                              )}
                              onChange={null}
                              inactive={true}
                            />
                            {(saleId === -1 || rectifyingInvoiceId !== -1) && (
                              <div className="sale-edit-address-icon">
                                <img
                                  src="/images/support-extra/editar.svg"
                                  onClick={() => showAddressPopup(true)}
                                />
                              </div>
                            )}
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">DNI / NIF</span>
                            </div>
                            <InputData
                              tabIndex={5}
                              type="type-alphanum"
                              size={0}
                              input={venta.nif}
                              onChange={onChangeDni}
                              inactive={
                                rectifyingInvoiceId === -1 && saleId !== -1
                              }
                              icon={
                                saleId === -1 || rectifyingInvoiceId !== -1
                                  ? "/images/link.svg"
                                  : undefined
                              }
                              onClick={() => showNifTypePopup(true)}
                            />
                            <span
                              style={{
                                fontWeight: 500,
                                marginLeft: 8,
                                alignSelf: "center",
                              }}
                            >
                              {venta.tipoDocumento
                                ? venta.tipoDocumento
                                : "01"}
                            </span>
                          </div>
                          <div className="screen-item fact">
                            <div
                              className="sale-fact-header"
                              onClick={toggleShowFactData}
                            >
                              <span>Datos de facturación</span>
                              <img
                                src={
                                  showFactData
                                    ? "/images/arrow-up.svg"
                                    : "/images/arrow-down.svg"
                                }
                              />
                            </div>
                            {showFactData && (
                              <div className="sale-fact-body">
                                <div className="sale-fact-body-data">
                                  <span>{venta.factName}</span>
                                  <span>
                                    {venta.factNif}
                                    <span
                                      style={{
                                        fontWeight: 500,
                                        marginLeft: 8,
                                      }}
                                    >
                                      {venta.factTipoDocumento
                                        ? venta.factTipoDocumento
                                        : "01"}
                                    </span>
                                  </span>
                                  <span>{venta.factAddress}</span>
                                  {venta.factName !== "" && (
                                    <span>
                                      {venta.factPostalCode}, {venta.factCity},{" "}
                                      {venta.factProvince}
                                    </span>
                                  )}
                                </div>
                                {(saleId === -1 ||
                                  rectifyingInvoiceId !== -1) && (
                                  <div className="sale-fact-body-option">
                                    <img
                                      src="/images/support-extra/editar.svg"
                                      onClick={() => showInvoicePopup(true)}
                                    />
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="screen-row-3">
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Nº operación</span>
                            </div>
                            <InputData
                              tabIndex={6}
                              type="type-alpha"
                              size={0}
                              input={venta.nOperation}
                              onChange={null}
                              inactive={true}
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Nº factura</span>
                            </div>
                            <InputData
                              tabIndex={7}
                              type="type-alpha"
                              size={0}
                              input={venta.nFact}
                              onChange={null}
                              inactive={true}
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Fecha</span>
                            </div>
                            <InputData
                              tabIndex={8}
                              type="type-alpha"
                              size={0}
                              input={moment(
                                venta.date,
                                "YYYY-MM-DD HH:mm:ss",
                              ).format("DD/MM/YYYY HH:mm:ss")}
                              onChange={null}
                              inactive={true}
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Teléfono</span>
                            </div>
                            <InputData
                              tabIndex={9}
                              type="type-phone"
                              size={1}
                              input={venta.phone}
                              onChange={onChangePhone}
                              inactive={
                                rectifyingInvoiceId === -1 && saleId !== -1
                              }
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Estado</span>
                            </div>
                            <InputData
                              tabIndex={10}
                              type="type-alpha"
                              size={0}
                              input={
                                rectifyingInvoiceId !== -1
                                  ? "RECTIFICANDO"
                                  : venta.status.toUpperCase()
                              }
                              onChange={null}
                              inactive={true}
                            />
                          </div>
                          {/* Ocupa el ancho de esta columna y la siguiente,
                              a la derecha de "Datos de facturación". */}
                          <div className="screen-item sale-description">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Descripción (*)</span>
                            </div>
                            {saleId !== -1 && rectifyingInvoiceId === -1 ? (
                              // Venta cerrada: se muestra el texto guardado
                              // tal cual, aunque ya no sea una opción.
                              <InputData
                                tabIndex={15}
                                type="type-alpha"
                                size={0}
                                input={filterDescription.text}
                                onChange={null}
                                inactive={true}
                              />
                            ) : (
                              <Dropdown
                                id="sales-filter-description"
                                tabIndex={15}
                                optionList={opticConfig.descriptionOptions}
                                size={1}
                                // Admite texto libre además de las opciones.
                                mandatory={false}
                                op={filterDescription.text}
                                onChange={setFilterDescription}
                                disabled={false}
                              />
                            )}
                          </div>
                        </div>
                        <div className="screen-row-3">
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">
                                {venta.id === -1
                                  ? "Puntos disp."
                                  : "Puntos canj. / gen."}
                              </span>
                            </div>
                            <InputData
                              tabIndex={11}
                              type="type-alpha"
                              size={0}
                              input={
                                loyaltyId === ""
                                  ? "-"
                                  : venta.id === -1
                                    ? formatNumber(loyaltyPoints) +
                                      " - " +
                                      formatCurrency(loyaltyPointsValue)
                                    : formatNumber(loyaltyPoints) +
                                      " - " +
                                      formatCurrency(loyaltyPointsValue) +
                                      " / " +
                                      formatNumber(loyaltyPointsGenerated) +
                                      " - " +
                                      formatCurrency(
                                        loyaltyPointsGeneratedValue,
                                      )
                              }
                              onChange={null}
                              inactive={true}
                            />
                            {/*<div className="screen-item-2 vale-caja">
                              <ButtonIconH
                                text="Canjear puntos"
                                onClick={() => {}}
                              />
                            </div>*/}
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Vale caja (€)</span>
                            </div>
                            <InputData
                              tabIndex={12}
                              type="type-alpha"
                              size={0}
                              input={venta.cashVouncher}
                              onChange={null}
                              inactive={true}
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Vendido por</span>
                            </div>
                            <Dropdown
                              id="sales-filter-realizado-por"
                              tabIndex={13}
                              optionList={agentsSoldBy}
                              size={1}
                              op={filterRealizadoPor.id}
                              onChange={
                                venta.id === -1
                                  ? onChangeFilterRealizadoPor
                                  : null
                              }
                              disabled={venta.id !== -1}
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Entregado por</span>
                            </div>
                            <Dropdown
                              id="sales-filter-entregado-por"
                              tabIndex={14}
                              optionList={agents}
                              size={1}
                              op={filterEntregadoPor.id}
                              onChange={onChangeFilterEntregadoPor}
                              disabled={false}
                            />
                          </div>
                          <div className="screen-item">
                            <div className="cell-extra cell-extra-big-label">
                              <span className="label">Campaña</span>
                            </div>
                            <Dropdown
                              id="sales-filter-campaign"
                              tabIndex={15}
                              optionList={campaigns}
                              size={1}
                              op={filterCampaign.id}
                              onChange={onChangeFilterCampaign}
                              disabled={
                                saleId !== -1 && rectifyingInvoiceId === -1
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="general-header-separator" />
                    <div className="general-header-buttons">
                      <ButtonIconV
                        text="Nuevo"
                        icon="/images/add-orange.svg"
                        onClick={() =>
                          onGoToScreen("venta", {
                            saleId: -1,
                          })
                        }
                      />
                      <ButtonIconV
                        text="Cancelar"
                        icon="/images/cancel-orange.svg"
                        onClick={() => onGoToScreen("ventas", true)}
                      />
                    </div>
                  </div>
                </div>

                {/* RECTIFICACION */}

                {rectifyingInvoiceId !== -1 && (
                  <div className="patient-search-content store-search-content">
                    <div className="opt-table-title">
                      <span>Opciones de rectificación</span>
                    </div>
                    <div className="screen-row screen-row-space-between screen-row-title">
                      <div className="sales-left">
                        <div
                          className={`radio-op radio-op-sales ${
                            venta.factType !== "Simple"
                              ? "radio-op-disabled"
                              : ""
                          }`}
                          onClick={() => {
                            if (venta.factType === "Simple") {
                              setRectificationType("simple");
                            }
                          }}
                        >
                          <RadioButton
                            tabIndex={500}
                            active={rectificationType === "simple"}
                            onClick={() => {}}
                          ></RadioButton>
                          <span className="label">
                            Rectificación factura simple
                          </span>
                        </div>
                        <div
                          className="radio-op radio-op-sales"
                          onClick={() => setRectificationType("completa")}
                        >
                          <RadioButton
                            tabIndex={501}
                            active={rectificationType === "completa"}
                            onClick={() => {}}
                          ></RadioButton>
                          <span className="label">
                            Rectificación factura completa
                          </span>
                        </div>
                      </div>
                      <div className="sales-right">
                        <div className="data-field">
                          <span className="label">Motivo:</span>
                          <InputData
                            id="rectificacion-motivo"
                            tabIndex={502}
                            type="type-alpha"
                            size={3}
                            maxLength={40}
                            input={rectificationReason}
                            onChange={setRectificationReason}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* VENTA */}

                <div className="patient-search-content store-search-content">
                  <div className="opt-table-title">
                    <span>Detalle de la venta</span>
                    {venta && venta.crossSelling && (
                      <div
                        className="crossselling-icon"
                        data-tooltip-id="ttt-crossselling"
                      >
                        <img
                          src="/images/support-extra/flechas-cruzadas.svg"
                          loading="lazy"
                          alt="load"
                        />
                        <TooltipBox
                          id="ttt-crossselling"
                          content={
                            <>
                              <div className="cell">
                                Nº operación: {venta.crossSelling.nOperation}
                              </div>
                              <div className="cell">
                                Tipo: {venta.crossSelling.type}
                              </div>
                              <div className="cell">
                                Agente: {venta.crossSelling.agent}
                              </div>
                            </>
                          }
                        />
                      </div>
                    )}
                  </div>
                  <div className="screen-row screen-row-space-between screen-row-title">
                    <div className="sales-left">
                      {saleId !== -1 &&
                        !venta.paid &&
                        venta.status !== "Anulada" &&
                        venta.status !== "Rectificada" &&
                        rectifyingInvoiceId === -1 && (
                          <ButtonIconH
                            text="Realizar pago"
                            disabled={false}
                            onClick={() => openPago()}
                          />
                        )}
                      {saleId !== -1 &&
                        venta.status !== "Anulada" &&
                        venta.status !== "Rectificada" &&
                        rectifyingInvoiceId === -1 && (
                          <ButtonIconH
                            text="Anular venta"
                            onClick={() => showCancelPopup(true)}
                            disabled={false}
                          />
                        )}
                      {saleId !== -1 &&
                        venta.factType === "Simple" &&
                        venta.status !== "Rectificada" &&
                        rectifyingInvoiceId === -1 && (
                          <ButtonIconH
                            text="Generar factura de canje"
                            onClick={openGenerateInvoice}
                            disabled={false}
                          />
                        )}
                      {saleId !== -1 &&
                        (venta.factType === "Simple" ||
                          venta.factType === "Completa" ||
                          venta.factType === "FacturaDeCanje") &&
                        venta.status !== "Rectificada" &&
                        venta.status !== "Anulada" &&
                        rectifyingInvoiceId === -1 && (
                          <ButtonIconH
                            text="Rectificar factura"
                            onClick={rectifyInvoice}
                            disabled={false}
                          />
                        )}
                      {saleId === -1 && (
                        <div
                          className="data-field c-pointer"
                          onClick={toggleFacturaCompleta}
                        >
                          <span className="label">Factura completa</span>
                          <CheckBox
                            tabIndex={16}
                            active={facturaCompleta}
                            onClick={() => {}}
                          />
                        </div>
                      )}
                      <ButtonIconH
                        text="Observaciones"
                        onClick={() => setShowObservationsPopup(true)}
                      />
                    </div>
                    <div className="sales-right">
                      <DropdownFilter
                        disabled={false}
                        optionList={
                          saleId === -1 || rectifyingInvoiceId !== -1
                            ? []
                            : [
                                /*{ id: "csv", text: "CSV" },*/
                                { id: "excel", text: "Excel" },
                                /*{ id: "pdf", text: "PDF" },*/
                              ]
                        }
                        op={"EXPORTAR COMO"}
                        selectedOptions={[]}
                        onChange={async (e) => {
                          if (e.id === "excel") {
                            await exportSaleReport(e.id);
                          }
                        }}
                      />
                      <DropdownFilter
                        disabled={false}
                        optionList={printDocumentOptions}
                        op={"IMPRIMIR"}
                        selectedOptions={[]}
                        onChange={(e) => {
                          if (e.id in INVOICE_TYPE_TO_TIPO_FACTURA) {
                            if (
                              [
                                "imp-ticket",
                                "imp-ticket-abono",
                                "imp-ticket-rect",
                              ].includes(e.id)
                            ) {
                              printInvoiceDirect({
                                idVenta: saleId,
                                invoiceType: e.id,
                                printObservations: false,
                                printPayments: false,
                                opticConfig,
                                createPopupQuestion,
                                removePopupQuestion,
                              });
                            } else {
                              setInvoicePrintingType(e.id);
                              setShowInvoicePrintingPopup(true);
                            }
                          }
                        }}
                      />
                      <ButtonIconH
                        text="Email"
                        onClick={() => setShowPrintingSalePopup(true)}
                        disabled={saleId === -1 || rectifyingInvoiceId !== -1}
                      />
                    </div>
                  </div>
                  <div className="screen-item sales-table sales-table-item">
                    <DataTable
                      columns={ventaColumns}
                      data={ventaLinesTable}
                      className="custom-datatable navtable"
                      noDataComponent={""}
                      onRowClicked={(row, event) => {}}
                      onditionalRowStyles={conditionalRowStyles}
                    />
                  </div>
                  {(saleId === -1 || rectifyingInvoiceId !== -1) && (
                    <div className="sales-view-more sales-view-more-options">
                      {rectifyingInvoiceId === -1 && (
                        <ButtonIconH
                          text="Añadir desde cesta"
                          onClick={() => showPopupCart(true)}
                        />
                      )}
                    </div>
                  )}
                </div>

                {/* DESGLOSE */}

                <div className="patient-search-content store-search-content">
                  <div className="opt-table-title">
                    <span>Desglose de la venta</span>
                  </div>
                  <div className="screen-row screen-row-space-between screen-row-title screen-row-total">
                    <div className="sales-left">
                      <div
                        className="data-field c-pointer"
                        onClick={markAsPaid}
                      >
                        <span className="label">Pagado</span>
                        <CheckBox
                          tabIndex={17}
                          active={
                            saleId !== -1 &&
                            venta.paid &&
                            rectifyingInvoiceId === -1
                          }
                          onClick={() => {}}
                        />
                      </div>
                      <div className="data-field">
                        <span className="label">Entregado</span>
                        <img
                          src={
                            filterEntregadoPor.id !== -1 &&
                            filterEntregadoPor.text !== ""
                              ? "/images/check-blue.svg"
                              : "/images/nocheck-blue.svg"
                          }
                          width={16}
                          height={16}
                          alt="Entregado"
                        />
                      </div>
                    </div>
                    <div className="sales-right">
                      <div className="screen-item screen-item-totals">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Total dto.</span>
                        </div>
                        <InputData
                          tabIndex={19}
                          type="type-alpha"
                          size={0}
                          input={totalDtoF}
                          onChange={null}
                          inactive={true}
                          extra="content-right"
                        />
                      </div>
                      <div className="screen-item screen-item-totals">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Total base</span>
                        </div>
                        <InputData
                          tabIndex={20}
                          type="type-alpha"
                          size={0}
                          input={totalBaseF}
                          onChange={null}
                          inactive={true}
                          extra="content-right"
                        />
                      </div>
                      <div className="screen-item screen-item-totals">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Total IVA</span>
                        </div>
                        <InputData
                          tabIndex={21}
                          type="type-alpha"
                          size={0}
                          input={totalIVAF}
                          onChange={null}
                          inactive={true}
                          extra="content-right"
                        />
                      </div>
                      <div className="screen-item screen-item-totals screen-item-totals-bold">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Total</span>
                        </div>
                        <InputDataCurrency
                          tabIndex={22}
                          type="type-alpha"
                          size={0}
                          input={venta.total.toString()}
                          onChange={(e) => {}}
                          onBlur={onBlurTotal}
                          onEnter={onBlurTotal}
                          inactive={saleId !== -1}
                          extra="content-right"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="screen-row screen-row-space-between screen-row-title">
                    <div className="sales-left sales-tables">
                      <div className="sales-table-left">
                        <div className="sale-table-header sale-table-pagos">
                          <div>
                            <span>Fecha</span>
                          </div>
                          <div>
                            <span>Abono</span>
                          </div>
                          <div>
                            <span>Forma de pago</span>
                          </div>
                          <div></div>
                        </div>
                        {venta.payments.map((item) => {
                          return (
                            <SaleTableItemPago
                              key={item.id}
                              id={item.id}
                              date={item.date}
                              amount={item.paid}
                              method={item.method}
                              onEdit={
                                venta.status === "Anulada" ||
                                venta.status === "Rectificada" ||
                                rectifyingInvoiceId !== -1
                                  ? null
                                  : onEditPayment
                              }
                            />
                          );
                        })}
                      </div>
                      <div className="sales-table-right">
                        <div className="sale-table-header sale-table-ivas">
                          <div>
                            <span>Base</span>
                          </div>
                          <div>
                            <span>% IVA</span>
                          </div>
                          <div>
                            <span>IVA</span>
                          </div>
                          <div>
                            <span>Total</span>
                          </div>
                        </div>
                        {venta.ivas.map((item) => {
                          return (
                            <SaleTableItemIVA
                              key={item.percIva}
                              base={item.base}
                              percIva={item.percIva}
                              iva={item.iva}
                              total={item.total}
                            />
                          );
                        })}
                      </div>
                    </div>
                    <div className="sales-right sales-right-total">
                      <div className="screen-item screen-item-totals">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Abonado</span>
                        </div>
                        <InputData
                          tabIndex={23}
                          type="type-alpha"
                          size={0}
                          input={
                            (saleId === -1 && rectifyingInvoiceId === -1) ||
                            venta.status === "Anulada"
                              ? ""
                              : formatCurrency(venta.totalPaid)
                          }
                          onChange={null}
                          inactive={true}
                          extra="content-right"
                        />
                      </div>
                      <div className="screen-item screen-item-totals screen-item-totals-bold">
                        <div className="cell-extra cell-extra-big-label">
                          <span className="label">Pendiente</span>
                        </div>
                        <InputData
                          tabIndex={24}
                          type="type-alpha"
                          size={0}
                          input={
                            (saleId === -1 && rectifyingInvoiceId === -1) ||
                            venta.status === "Anulada"
                              ? ""
                              : formatCurrency(venta.totalRemaining)
                          }
                          onChange={null}
                          inactive={true}
                          extra="content-right"
                        />
                      </div>
                    </div>
                  </div>
                  {(saleId === -1 || rectifyingInvoiceId !== -1) && (
                    <div className="screen-row screen-row-space-between screen-row-title screen-row-accept-venta">
                      <ButtonIconH
                        text={
                          rectifyingInvoiceId !== -1
                            ? "Rectificar"
                            : "Finalizar venta"
                        }
                        onClick={acceptVentaStep1}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {invoice && (
          <div className="popup-container secondary popup-calendar-event custom-popup-container">
            <div className="popup-message">
              <div className="popup-calendario">
                <PopupTitle
                  title="Datos de facturación"
                  onClose={() => showInvoicePopup(false)}
                />
              </div>
              <div className="popup-calendar-body">
                <div className="popup-calendar-contenido">
                  <div className="popup-calendar-contenido-element">
                    <div className="label">Cod. paciente</div>
                    <InputSearch
                      id="codigorec-fact"
                      size={1}
                      tabIndex={101}
                      link={true}
                      code={true}
                      op={invoice.codPaciente}
                      onSelect={onSelectFactPatient}
                      onClickLink={onLinkPatient}
                      showCode={true}
                      disabled={false}
                    />
                  </div>
                  <div className="popup-calendar-contenido-element">
                    <div className="label">Razón social / Nombre (*)</div>
                    <InputData
                      maxLength={60}
                      inactive={false}
                      type="type-alpha"
                      size={0}
                      input={invoice.name}
                      onChange={onChangeFactName}
                      tabIndex={102}
                    />
                  </div>
                  <div className="popup-calendar-contenido-element">
                    <div className="label">NIF / CIF (*)</div>
                    <InputData
                      maxLength={12}
                      inactive={false}
                      type="type-only-charnumbers"
                      size={0}
                      input={invoice.nif}
                      onChange={onChangeFactNIF}
                      tabIndex={103}
                      icon="/images/link.svg"
                      onClick={() => showNifTypePopup(true, "invoice")}
                    />
                    <span style={{ fontWeight: 500, marginLeft: 8 }}>
                      {invoice.tipoDocumento ? invoice.tipoDocumento : "01"}
                    </span>
                  </div>
                  <div className="popup-calendar-contenido-element">
                    <div className="label">Dirección (*)</div>
                    <InputData
                      maxLength={60}
                      inactive={false}
                      type="type-alphanum-ext"
                      size={0}
                      input={invoice.address}
                      onChange={onChangeFactAddress}
                      tabIndex={104}
                    />
                  </div>
                  <div className="popup-calendar-contenido-element">
                    <div className="label">Localidad (*)</div>
                    <InputData
                      maxLength={60}
                      inactive={false}
                      type="type-alpha"
                      size={0}
                      input={invoice.city}
                      onChange={onChangeFactCity}
                      tabIndex={105}
                    />
                    <div className="label">CP (*)</div>
                    <InputData
                      id="cp-invoice"
                      maxLength={5}
                      inactive={false}
                      type="type-cp"
                      size={0}
                      input={invoice.postalCode}
                      onChange={onChangeFactPostalCode}
                      onMalformed={() => setErrorCP("cp-invoice")}
                      error={errorCP === "cp-invoice"}
                      tabIndex={106}
                      icon="/images/link.svg"
                      onClick={() =>
                        showPopupCPDialog(
                          true,
                          invoice.address,
                          invoice.city,
                          "invoice",
                        )
                      }
                    />
                  </div>
                  <div className="popup-calendar-contenido-element">
                    <div className="label">Provincia (*)</div>
                    <Dropdown
                      tabIndex={107}
                      id="provincia"
                      disabled={false}
                      optionList={provinceOptions}
                      size={3}
                      op={invoice.province}
                      onChange={onChangeFactProvince}
                    />
                  </div>
                  <div className="popup-calendar-contenido-element popup-calendar-contenido-element-buttons">
                    <div className="popup-row-buttons">
                      <ButtonIconH
                        text={generatingInvoice ? "Generar factura" : "Guardar"}
                        onClick={
                          generatingInvoice ? generateInvoice : saveInvoice
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {address && (
          <div className="popup-container secondary popup-calendar-event custom-popup-container">
            <div className="popup-message">
              <div className="popup-calendario">
                <PopupTitle
                  title="Dirección"
                  onClose={() => showAddressPopup(false)}
                />
              </div>
              <div className="popup-calendar-body">
                <div className="popup-calendar-contenido">
                  <div className="popup-calendar-contenido-element">
                    <div className="label">Dirección</div>
                    <InputData
                      maxLength={60}
                      inactive={false}
                      type="type-alphanum-ext"
                      size={0}
                      input={address.address}
                      onChange={onChangeAddress}
                      tabIndex={101}
                    />
                  </div>
                  <div className="popup-calendar-contenido-element">
                    <div className="label">Localidad</div>
                    <InputData
                      maxLength={60}
                      inactive={false}
                      type="type-alpha"
                      size={0}
                      input={address.city}
                      onChange={onChangeCity}
                      tabIndex={102}
                    />
                    <div className="label">CP</div>
                    <InputData
                      id="cp-address"
                      maxLength={5}
                      inactive={false}
                      type="type-cp"
                      size={0}
                      input={address.postalCode}
                      onChange={onChangePostalCode}
                      onMalformed={() => setErrorCP("cp-address")}
                      error={errorCP === "cp-address"}
                      tabIndex={103}
                      icon="/images/link.svg"
                      onClick={() =>
                        showPopupCPDialog(
                          true,
                          address.address,
                          address.city,
                          "personal",
                        )
                      }
                    />
                  </div>
                  <div className="popup-calendar-contenido-element">
                    <div className="label">Provincia</div>
                    <Dropdown
                      tabIndex={104}
                      id="provincia"
                      disabled={false}
                      optionList={provinceOptions}
                      size={3}
                      op={address.province}
                      onChange={onChangeProvince}
                    />
                  </div>
                  <div className="popup-calendar-contenido-element popup-calendar-contenido-element-buttons">
                    <div className="popup-row-buttons">
                      <ButtonIconH text="Guardar" onClick={saveAddress} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {payment && (
          <div className="popup-container popup-normal popup-receipt">
            <div className="popup-message">
              <div className="popup-header">
                <div className="popup-title">Realizar pago</div>
                <img
                  src="/images/close-white.svg"
                  loading="lazy"
                  alt=""
                  className="popup-close"
                  onClick={closeVenta}
                />
              </div>
              <div className="popup-body">
                <PopupSectionTitle title="Operación de venta" />
                <div className="popup-row popup-row-receipt">
                  <div className="popup-receipt-left">
                    <div className="popup-row">
                      <div className="label">Forma de pago</div>
                      <Dropdown
                        tabIndex={202}
                        id="provincia"
                        disabled={false}
                        optionList={paymentPopupMethods}
                        size={3}
                        op={payment.paymentMethod.id}
                        onChange={onChangePaymentMethod}
                      />
                    </div>
                    {payment.paymentMethod.text !== "VALE DE CAJA" && (
                      <div className="popup-row">
                        <div className="label">Tipo de tarjeta</div>
                        <Dropdown
                          tabIndex={203}
                          id="tipoTarjeta"
                          optionList={cardTypes}
                          size={3}
                          op={payment.cardType.id}
                          onChange={onChangeCardType}
                          disabled={
                            paymentMethods.find((item) => {
                              return item.text === "TARJETA";
                            }).id !== payment.paymentMethod.id
                          }
                        />
                      </div>
                    )}
                    {payment.paymentMethod.text === "VALE DE CAJA" && (
                      <div className="popup-row">
                        <div className="label">Vales de caja</div>
                        <Dropdown
                          tabIndex={203}
                          id="valeCaja"
                          optionList={cashVouchers}
                          size={3}
                          op={payment.cashVoucher?.id}
                          onChange={onChangeCashVoucher}
                          disabled={false}
                        />
                      </div>
                    )}
                    <div className="popup-row">
                      <div className="label">
                        {saleId === -1 ? "Vendido por" : "Realizado por"}
                      </div>
                      <Dropdown
                        tabIndex={204}
                        id="pago-vendido-por"
                        disabled={false}
                        optionList={agentsSoldBy}
                        size={3}
                        op={payment.soldBy.id}
                        onChange={onChangeFilterRealizadoPorPayment}
                      />
                    </div>
                    {saleId === -1 && (
                      <div className="popup-row">
                        <div className="label">Entregado por</div>
                        <Dropdown
                          tabIndex={205}
                          id="pago-entregado-por"
                          disabled={false}
                          optionList={agents}
                          size={3}
                          op={payment.deliveredBy.id}
                          onChange={onChangeFilterEntregadoPorPayment}
                        />
                      </div>
                    )}
                  </div>
                  <div className="popup-receipt-right">
                    {saleId === -1 && (
                      <div className="popup-row">
                        <div className="label">Total</div>
                        <InputDataCurrency
                          tabIndex={206}
                          type="type-alpha"
                          size={0}
                          input={payment.total.toString()}
                          onChange={(e) => {}}
                          onBlur={null}
                          inactive={true}
                          extra="content-right"
                        />
                      </div>
                    )}
                    {rectifyingInvoiceId !== -1 && (
                      <div className="popup-row">
                        <div className="label">Pagado</div>
                        <div className="label rectifying-invoice-total-paid">
                          {formatCurrency(rectifyingInvoiceTotalPaid)}
                        </div>
                      </div>
                    )}
                    <div className="popup-row">
                      <div className="label">Entregado</div>
                      <InputDataCurrency
                        id="p-sale-delivered"
                        tabIndex={201}
                        type="type-alpha"
                        size={0}
                        input={payment.delivered.toString()}
                        onChange={(e) => {}}
                        onBlur={onChangeDelivered}
                        inactive={payment.paymentMethod.text === "VALE DE CAJA"}
                        extra="content-right"
                      />
                    </div>
                    <div className="popup-row">
                      <div className="label">Cambio</div>
                      <InputDataCurrency
                        tabIndex={207}
                        type="type-alpha"
                        size={0}
                        input={payment.change.toString()}
                        onChange={(e) => {}}
                        onBlur={null}
                        inactive={true}
                        extra="content-right"
                      />
                    </div>
                    <div className="popup-row">
                      <div className="label">Pendiente</div>
                      <InputDataCurrency
                        tabIndex={208}
                        type="type-alpha"
                        size={0}
                        input={payment.pending.toString()}
                        onChange={(e) => {}}
                        onBlur={null}
                        inactive={true}
                        extra="content-right"
                      />
                    </div>
                  </div>
                </div>

                {saleId === -1 && (
                  <PopupSectionTitle title="Sistema de fidelización" />
                )}
                {saleId === -1 && opticConfig.idFidelizacion === "" && (
                  <div className="patientnoloyalty">
                    La óptica no tiene perfil de fidelización.
                  </div>
                )}
                {saleId === -1 &&
                  opticConfig.idFidelizacion !== "" &&
                  loyaltyId === "" && (
                    <div className="patientnoloyalty">
                      El paciente no tiene fidelización.
                    </div>
                  )}
                {saleId === -1 && loyaltyId !== "" && (
                  <PopupPaymentPointsItem
                    description="Puntos disponibles"
                    points={loyaltyPoints}
                    currency={loyaltyPointsValue}
                  />
                )}
                {saleId === -1 && loyaltyId !== "" && (
                  <div className="popup-row popup-row-payment-points-item">
                    <span className="popup-row-payment-points-item-description">
                      Canjeo de puntos (€):
                    </span>
                    <InputData
                      maxLength={8}
                      type="type-float2"
                      size={1}
                      input={loyaltyPointsAppliedValue}
                      onChange={onChangeLoyaltyPointsApplied}
                      tabIndex={103}
                      onBlur={onSubmitLoyaltyPointsApplied}
                    />
                    <span className="popup-row-payment-points-item-description">
                      / Puntos: {formatNumber(loyaltyPointsApplied)}
                    </span>
                    {/*<span>
                    {points} ({formatCurrency(currency)})
                  </span>*/}
                  </div>
                )}
                {saleId === -1 && loyaltyId !== "" && (
                  <PopupPaymentPointsItem
                    description="Puntos generados"
                    points={loyaltyPointsGenerated}
                    currency={loyaltyPointsGeneratedValue}
                  />
                )}
                {payment.crossSelling.nOperation !== "" && (
                  <PopupSectionTitle title="Cross selling" />
                )}
                {payment.crossSelling.nOperation !== "" && (
                  <div className="popup-row crossselling-section">
                    <div className="crossselling-info">
                      <PopupTitleDescriptionItem
                        title="Nº operación"
                        description={payment.crossSelling.nOperation}
                      />
                      <PopupTitleDescriptionItem
                        title="Tipo"
                        description={payment.crossSelling.type}
                      />
                      <PopupTitleDescriptionItem
                        title="Agente"
                        description={
                          agents.find((item) => {
                            return payment.crossSelling.agent === item.id;
                          }).text
                        }
                      />
                      <PopupTitleDescriptionItem
                        title="Total"
                        description={payment.crossSelling.sale.total}
                      />
                    </div>
                    <img
                      className="crossselling-trash"
                      src="/images/remove-blue.svg"
                      onClick={removeCrossSelling}
                    />
                  </div>
                )}
                {saleId === -1 && (
                  <PopupSectionTitle title="Justificante de venta" />
                )}
                {saleId === -1 && (
                  <div className="popup-row">
                    <div
                      className={
                        "radio-op radio-op-sales" +
                        (facturaCompleta ? " radio-op-disabled" : "")
                      }
                      onClick={() =>
                        !facturaCompleta &&
                        onTogglePaymentReceipt("receiptTicket")
                      }
                    >
                      <CheckBox
                        tabIndex={209}
                        active={payment.receiptTicket}
                        disabled={facturaCompleta}
                        onClick={() => {}}
                      />
                      <span className="label">Formato ticket</span>
                    </div>
                    <div
                      className={
                        "radio-op radio-op-sales" +
                        (!facturaCompleta ? " radio-op-disabled" : "")
                      }
                      onClick={() =>
                        facturaCompleta && onTogglePaymentReceipt("receiptA4")
                      }
                    >
                      <CheckBox
                        tabIndex={210}
                        active={payment.receiptA4}
                        disabled={!facturaCompleta}
                        onClick={() => {}}
                      />
                      <span className="label">Formato A4</span>
                    </div>
                    <div
                      className="radio-op radio-op-sales"
                      onClick={() => onTogglePaymentReceipt("receiptEmail")}
                    >
                      <CheckBox
                        tabIndex={211}
                        active={payment.receiptEmail}
                        disabled={false}
                        onClick={() => {}}
                      />
                      <span className="label">Enviar por E-Mail</span>
                    </div>
                  </div>
                )}
              </div>
              <div className="popup-footer">
                <div className="popup-calendar-contenido-element popup-calendar-contenido-element-buttons">
                  <div className="popup-row-buttons">
                    <ButtonIconH
                      text="Guardar"
                      disabled={savingPayment}
                      onClick={saleId === -1 ? saveSale : performPayment}
                    />
                    {saleId === -1 && (
                      <div className="popup-floating-button">
                        <ButtonIconH
                          text="Cross Selling"
                          onClick={() => showCrossSellingPopup(true)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {editPayment && (
          <div className="popup-container popup-normal popup-receipt">
            <div className="popup-message">
              <div className="popup-header">
                <div className="popup-title">Editar pago</div>
                <img
                  src="/images/close-white.svg"
                  loading="lazy"
                  alt=""
                  className="popup-close"
                  onClick={closeEditPayment}
                />
              </div>
              <div className="popup-body">
                <PopupSectionTitle title="Operación de venta" />
                <div className="popup-row popup-row-receipt">
                  <div className="popup-receipt-left">
                    <div className="popup-row">
                      <div className="label">Forma de pago</div>
                      <Dropdown
                        tabIndex={202}
                        id="edit-payment-forma-pago"
                        disabled={false}
                        optionList={paymentMethods.filter((item) => {
                          return item.text !== "VALE DE CAJA";
                        })}
                        size={3}
                        op={editPayment.paymentMethod.id}
                        onChange={onChangeEditPaymentMethod}
                      />
                    </div>
                    <div className="popup-row">
                      <div className="label">Tipo de tarjeta</div>
                      <Dropdown
                        tabIndex={203}
                        id="edit-payment-tipo-tarjeta"
                        optionList={cardTypes}
                        size={3}
                        op={editPayment.cardType.id}
                        onChange={onChangeEditPaymentCardType}
                        disabled={
                          paymentMethods.find((item) => {
                            return item.text === "TARJETA";
                          }).id !== editPayment.paymentMethod.id
                        }
                      />
                    </div>
                    <div className="popup-row">
                      <div className="label">Realizado por</div>
                      <Dropdown
                        tabIndex={204}
                        id="edit-payment-realizado-por"
                        disabled={false}
                        optionList={agentsSoldBy}
                        size={3}
                        op={editPayment.soldBy.id}
                        onChange={onChangeEditPaymentSoldBy}
                      />
                    </div>
                  </div>
                  <div className="popup-receipt-right">
                    <div className="popup-row">
                      <div className="label">Entregado</div>
                      <InputDataCurrency
                        key={editPaymentDeliveredKey}
                        id="p-edit-payment-delivered"
                        tabIndex={201}
                        type="type-alpha"
                        size={0}
                        input={editPayment.delivered.toString()}
                        onChange={(e) => {}}
                        onBlur={onChangeEditPaymentDelivered}
                        inactive={
                          editPayment.paymentMethod.text === "VALE DE CAJA"
                        }
                        extra="content-right"
                      />
                    </div>
                    <div className="popup-row">
                      <div className="label">Pendiente</div>
                      <InputDataCurrency
                        tabIndex={205}
                        type="type-alpha"
                        size={0}
                        input={editPayment.pending.toString()}
                        onChange={(e) => {}}
                        onBlur={null}
                        inactive={true}
                        extra="content-right"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="popup-footer">
                <div className="popup-calendar-contenido-element popup-calendar-contenido-element-buttons">
                  <div className="popup-row-buttons">
                    <ButtonIconH text="Guardar" onClick={saveEditPayment} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {cartPopup && (
          <div className="popup-container popup-normal popup-carts-sales">
            <div className="popup-message">
              <div className="popup-header">
                <div className="popup-title">Añadir desde cesta</div>
                <img
                  src="/images/close-white.svg"
                  loading="lazy"
                  alt=""
                  className="popup-close"
                  onClick={() => showPopupCart(false)}
                />
              </div>
              {cartPopup.length > 0 && (
                <div className="popup-body">
                  {cartPopup.map((cart, index) => {
                    return (
                      <CartItem
                        key={index}
                        patientCode={cart.patientCode}
                        patientNameLastName={cart.patientNameLastName}
                        patientPic={cart.patientPic}
                        cardType={cart.cardType}
                        total={cart.total}
                        selected={cart.selected}
                        onClickCartItem={() => onClickCartItem(index)}
                      />
                    );
                  })}
                </div>
              )}
              {cartPopup.length === 0 && (
                <div className="popup-body">
                  <div className="popup-body-no-message">
                    <span>No existen cestas pendientes de procesar.</span>
                  </div>
                </div>
              )}
              <div className="popup-footer">
                <div className="popup-calendar-contenido-element popup-calendar-contenido-element-buttons">
                  <div className="popup-row-buttons">
                    {cartPopup.length > 0 ? (
                      <ButtonIconH
                        text="Añadir a venta"
                        onClick={addCartToSale}
                      />
                    ) : (
                      <ButtonIconH
                        text="Cerrar"
                        onClick={() => showPopupCart(false)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {crossSellingPopup && (
          <div className="popup-container secondary popup-calendar-event custom-popup-container">
            <div className="popup-message">
              <div className="popup-calendario">
                <PopupTitle
                  title="Cross Selling"
                  onClose={() => showCrossSellingPopup(false)}
                />
              </div>
              <div className="popup-calendar-body">
                <div className="popup-calendar-contenido">
                  <div className="popup-calendar-contenido-element">
                    <div className="label">Nº operación</div>
                    <InputData
                      inactive={false}
                      type="type-only-numbers"
                      size={0}
                      input={crossSellingPopup.nOperation}
                      onChange={onChangeCrossSellingNOperation}
                      tabIndex={301}
                      onBlur={loadVentaCrossSelling}
                      icon="/images/search-blue.svg"
                    />
                  </div>
                  <PopupDescriptionItem
                    title="Fecha"
                    text={crossSellingPopup.sale.date}
                  />
                  <PopupDescriptionItem
                    title="Agente"
                    text={crossSellingPopup.sale.agent}
                  />
                  <PopupDescriptionItem
                    title="Paciente"
                    text={crossSellingPopup.sale.patient}
                  />
                  <PopupSectionTitle title="Productos" />
                  <div className="popup-crossselling-products">
                    {crossSellingPopup.sale.lines.map((item) => {
                      return (
                        <PopupCrossSellingLineItem
                          key={item.id}
                          product={item.description}
                          total={item.total}
                        />
                      );
                    })}
                  </div>
                  <PopupSectionTitle title="Desglose de la venta" />
                  <div className="popup-crossselling-desglose">
                    <div>
                      <span className="popup-crossselling-desglose-title">
                        Total:
                      </span>
                      <span>{crossSellingPopup.sale.total}</span>
                    </div>
                    <div>
                      <span className="popup-crossselling-desglose-title">
                        Abonado:
                      </span>
                      <span>{crossSellingPopup.sale.delivered}</span>
                    </div>
                    <div>
                      <span className="popup-crossselling-desglose-title">
                        Pendiente:
                      </span>
                      <span>{crossSellingPopup.sale.remaining}</span>
                    </div>
                  </div>
                  <div className="popup-calendar-contenido-element popup-crossselling-contenido-element-desglose">
                    <div className="label">Tipo</div>
                    <Dropdown
                      id="crossselling-filter-tipo"
                      tabIndex={302}
                      optionList={tiposCrossSelling}
                      size={1}
                      op={crossSellingPopup.type}
                      onChange={onChangeFilterCrossSellingType}
                      disabled={false}
                    />
                  </div>
                  <div className="popup-calendar-contenido-element popup-crossselling-contenido-element-desglose">
                    <div className="label">Agente</div>
                    <Dropdown
                      id="crossselling-filter-agente"
                      tabIndex={303}
                      optionList={agents}
                      size={1}
                      op={filterCrossSellingAgente.id}
                      onChange={onChangeFilterCrossSellingAgent}
                      disabled={false}
                    />
                  </div>
                  <div className="popup-calendar-contenido-element popup-calendar-contenido-element-buttons">
                    <div className="popup-row-buttons">
                      <ButtonIconH
                        text="Asignar"
                        onClick={assignCrossSelling}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {nifTypePopup && (
          <PopupNIFTypes
            idNif={
              nifTypePopupTarget === "invoice" ? invoice.nifType : venta.nifType
            }
            onClick={() => showNifTypePopup(false)}
            onAccept={(e) => acceptNifTypePopup(e)}
          />
        )}
        {showHealthControlPopup && (
          <div className="popup-container secondary popup-calendar-event custom-popup-container popup-control-sanitario">
            <div className="popup-message">
              <div className="popup-calendario">
                <PopupTitle
                  title="Control sanitario"
                  onClose={() => acceptHealthControl([])}
                />
              </div>
              <div className="popup-calendar-body">
                <HealthData
                  patientId={venta.codPaciente}
                  lines={healthControlPopupItems}
                  createPopupQuestion={createPopupQuestion}
                  removePopupQuestion={removePopupQuestion}
                  onAccept={(list) => acceptHealthControl(list)}
                  mode="sale"
                />
              </div>
            </div>
          </div>
        )}
        {cancellationPopup && (
          <div className="popup-container popup-normal popup-receipt">
            <div className="popup-message">
              <div className="popup-header">
                <div className="popup-title">
                  {rectifyingInvoiceId !== -1 ? "Devolución" : "Anular venta"}
                </div>
                <img
                  src="/images/close-white.svg"
                  loading="lazy"
                  alt=""
                  className="popup-close"
                  onClick={() => showCancelPopup(false)}
                />
              </div>
              <div className="popup-body">
                <div className="popup-row popup-row-cancellation-item">
                  <span className="popup-row-cancellation-item-description">
                    Cantidad a devolver:
                  </span>
                  <span>-{formatCurrency(cancellationPopup.price)}</span>
                </div>
                <PopupVerticalSpacer height={5} />
                <div
                  className="radio-op radio-op-sales"
                  onClick={() => onChangeCancellationWay("Original")}
                >
                  <RadioButton
                    tabIndex={401}
                    active={cancellationPopup.cancellationWay === "Original"}
                    onClick={() => {}}
                  ></RadioButton>
                  <span className="label">
                    Devolución a forma de pago original
                  </span>
                </div>
                <div className="popup-tab">
                  <div className="popup-row popup-row-cancellation-item">
                    <span>{cancellationPopup.sellingPaymentMethod}</span>
                  </div>
                </div>
                <div
                  className="radio-op radio-op-sales"
                  onClick={() => onChangeCancellationWay("PagoDiferente")}
                >
                  <RadioButton
                    tabIndex={402}
                    active={
                      cancellationPopup.cancellationWay === "PagoDiferente"
                    }
                    onClick={() => {}}
                  ></RadioButton>
                  <span className="label">
                    Devolución a forma de pago diferente
                  </span>
                </div>
                <div className="popup-tab">
                  <div className="popup-row">
                    <div className="label">Forma de pago</div>
                    <Dropdown
                      tabIndex={403}
                      id="provincia"
                      optionList={paymentMethods}
                      size={3}
                      op={cancellationPopup.paymentMethod.id}
                      onChange={onChangeCancellationPaymentMethod}
                      disabled={
                        cancellationPopup.cancellationWay === "Original"
                      }
                    />
                  </div>
                  <div className="popup-row">
                    <div className="label">Tipo tarjeta</div>
                    <Dropdown
                      tabIndex={404}
                      id="tipoTarjeta"
                      optionList={cardTypes}
                      size={3}
                      op={cancellationPopup.cardType.id}
                      onChange={onChangeCancellationCardType}
                      disabled={
                        cancellationPopup.cancellationWay === "Original" ||
                        paymentMethods.find((item) => {
                          return item.text === "TARJETA";
                        }).id !== cancellationPopup.paymentMethod.id
                      }
                    />
                  </div>
                </div>
                {rectifyingInvoiceId === -1 && (
                  <PopupVerticalSpacer height={5} />
                )}
                {rectifyingInvoiceId === -1 && (
                  <div className="popup-row popup-row-top">
                    <div className="label">Motivo</div>
                    <Dropdown
                      tabIndex={405}
                      id="motivoAnulacion"
                      optionList={motivosAnulacion}
                      size={3}
                      op={cancellationPopup.reason.id}
                      onChange={onChangeCancellationReason}
                      disabled={false}
                    />
                  </div>
                )}
                {rectifyingInvoiceId === -1 && (
                  <div className="popup-row">
                    <div className="label">Agente</div>
                    <Dropdown
                      tabIndex={406}
                      id="pago-vendido-por"
                      disabled={false}
                      optionList={agents}
                      size={3}
                      op={cancellationPopup.agent.id}
                      onChange={onChangeCancellationAgent}
                    />
                  </div>
                )}
              </div>
              <div className="popup-footer">
                <div className="popup-calendar-contenido-element popup-calendar-contenido-element-buttons">
                  <div className="popup-row-buttons">
                    <ButtonIconH text="Aceptar" onClick={cancelSell} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/*<PopupPin
          id="popup-pin-sale"
          show={pinPopup}
          agentId={pinPopupAgentid}
          agentName={pinPopupAgentName}
          onAccept={pinPopupOnAccept}
          onCancel={pinPopupOnCancel}
        />*/}
        <PopupCP
          show={showPopupCP}
          direccion={cpPopupAddress}
          localidad={cpPopupCity}
          onAccept={(fullAddress) => onAcceptCP(fullAddress)}
          onCancel={() => showPopupCPDialog(false, "", "", "personal")}
        />
        <PopupPrintingSale
          show={showPrintingSalePopup}
          idVenta={saleId}
          documentOptions={printDocumentOptions}
          onClose={() => setShowPrintingSalePopup(false)}
          onSent={async (adjunto) => {
            setEmailAttachments([adjunto]);
            const nombreFactura = adjunto.titulo.replace(/\.[^/.]+$/, "");
            setEmailAsunto(("Factura " + nombreFactura).toUpperCase());

            let email = "";
            if (venta.idPaciente && venta.idPaciente !== -1) {
              const response = await post("ObtenerDatosPaciente.php", {
                token: userData.token,
                optica: selectedOptic.id,
                idPaciente: venta.idPaciente,
              });
              email = response?.email ?? "";
            }
            setEmailDestinatario(email);

            setShowEmailPopup(true);
          }}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
        <PopupEmail
          show={showEmailPopup}
          destinatario={emailDestinatario}
          asunto={emailAsunto}
          adjuntos={emailAttachments}
          onCancel={() => {
            setShowEmailPopup(false);
            if (paymentEmailIdVenta !== null) {
              const idVenta = paymentEmailIdVenta;
              setPaymentEmailIdVenta(null);
              finishSaleCreation(idVenta);
            }
          }}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
        <PopupInvoicePrinting
          show={showInvoicePrintingPopup}
          idVenta={saleId}
          invoiceType={invoicePrintingType}
          opticConfig={opticConfig}
          onClose={() => setShowInvoicePrintingPopup(false)}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
        <PopupSaleObservations
          show={showObservationsPopup}
          obs={venta.observations}
          saveButtonText={
            saleId !== -1 && rectifyingInvoiceId === -1 ? "Guardar" : "Aceptar"
          }
          onClose={() => setShowObservationsPopup(false)}
          onSave={async (obs) => {
            const ventaN = structuredClone(venta);
            ventaN.observations = obs;
            setVenta(ventaN);

            if (saleId !== -1 && rectifyingInvoiceId === -1) {
              await rpost("ventas/GuardarObservacionesVenta.php", {
                token: userData.token,
                idVenta: venta.id,
                observaciones: obs,
              });

              createPopupQuestion(
                "Observaciones guardadas de manera correcta.",
                removePopupQuestion,
                null,
                "Cerrar",
              );
            }
          }}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      </div>
    );
  },
);

/*const ventaOr = {
  id: 34,
  idPaciente: 1,
  codPaciente: 1,
  name: "ALEJANDRO",
  lastName: "CRISTO GARCÍA",
  address: "C/ BEATA MADRE MATILDE Nº 2, 4º A",
  city: "CÁCERES",
  province: "CACERES",
  postalCode: "10001",
  nif: "76037820-G",
  nifType: "00",
  factCodPaciente: 1,
  factName: "HIMALAYA COMPUTING S.L.",
  factNif: "B10466464",
  factAddress: "AV/ HERNÁN CORTÉS 34, ENTREPLANTA",
  factCity: "CÁCERES",
  factProvince: "CACERES",
  factPostalCode: "10004",
  factType: "",
  nOperation: "56674",
  nFact: "23455",
  date: "2025-02-08 10:01:54",
  phone: "685608842",
  status: "Venta",
  points: 100,
  cashVouncher: 30,
  soldBy: 1,
  deliveredBy: 1,
  campaign: 1,
  lines: [
    {
      id: 45,
      code: "1000011112",
      description: "MONTURA GLASS LUXURY GOLD ESTRELLA",
      pvpOr: 110.3,
      pvp: 110.3,
      dto: 1,
      ivaOr: 21,
      iva: 21,
      pvu: 109.2,
      uds: 1,
      total: 109.2,
      stock: 30,
      dtoMax: 0,
      pvpOffer: -1,
      offerFrom: "",
      offerTo: "",
      pvpSpecial: -1,
      specialUds: 0,
      checkStock: false,
      healthControl: null,
    },
    {
      id: 46,
      code: "1000011252",
      description: "MONTURA RAYBAN NEGRA PASTA2",
      pvpOr: 400,
      pvp: 400,
      dto: 10,
      ivaOr: 21,
      iva: 21,
      pvu: 360,
      uds: 2,
      total: 720,
      stock: 11,
      dtoMax: 0,
      pvpOffer: -1,
      offerFrom: "",
      offerTo: "",
      pvpSpecial: -1,
      specialUds: 0,
      checkStock: false,
      healthControl: null,
    },
    {
      id: 47,
      code: "6001023453",
      description: "LIQUIDO LIMPIEZA CRISTALES SUPER CLEAN GLASSR",
      pvpOr: 9.9,
      pvp: 9.9,
      dto: 0,
      ivaOr: 21,
      iva: 21,
      pvu: 9.9,
      uds: 10,
      total: 99,
      stock: 0,
      dtoMax: 0,
      pvpOffer: -1,
      offerFrom: "",
      offerTo: "",
      pvpSpecial: -1,
      specialUds: 0,
      checkStock: false,
      healthControl: null,
    },
  ],
  paid: false,
  delivered: false,
  totalDto: 243.31,
  totalBase: 2137.69,
  totalIVA: 448.91,
  total: 2586.6,
  totalPaid: 2000,
  totalRemaining: 586.6,
  payments: [
    {
      id: 1,
      date: "2025-01-04",
      paid: 500,
      method: "AL CONTADO",
      card: "",
    },
    {
      id: 2,
      date: "2025-01-05",
      paid: 1450,
      method: "TARJETA",
      card: "VISA",
    },
    {
      id: 3,
      date: "2025-01-10",
      paid: 50,
      method: "TARJETA",
      card: "MASTERCARD",
    },
  ],
  ivas: [],
  carts: [
    {
      id: 100,
      patientCode: "40",
      patientNameLastName: "ALEJANDRO CRISTO GARCÍA",
      patientPic: "",
      lines: [
        {
          id: "c-10045",
          code: "1000011122",
          description: "MONTURA RED STORM",
          pvp: 110.3,
          dto: 1,
          iva: 21,
          pvu: 109.2,
          uds: 1,
          total: 109.2,
          stock: 11,
          healthControl: null,
        },
        {
          id: "c-10046",
          code: "1000031252",
          description: "GAFAS RED STORM",
          pvp: 400,
          dto: 10,
          iva: 21,
          pvu: 360,
          uds: 2,
          total: 720,
          stock: 0,
          healthControl: null,
        },
      ],
    },
    {
      id: 101,
      patientCode: "41",
      patientNameLastName: "ALEXANDRE CHRIST COUPE",
      patientPic: "",
      lines: [
        {
          id: "c-10145",
          code: "1003011122",
          description: "LENTILLAS BLANCAS ESTILO GOTH",
          pvp: 110.3,
          dto: 1,
          iva: 21,
          pvu: 109.2,
          uds: 1,
          total: 109.2,
          stock: 55,
          healthControl: null,
        },
        {
          id: "c-10146",
          code: "1004031252",
          description: "LENTILLAS FIESTA LAGARTO RR-JULK",
          pvp: 400,
          dto: 10,
          iva: 21,
          pvu: 360,
          uds: 2,
          total: 720,
          stock: 111,
          healthControl: null,
        },
      ],
    },
  ],
  crossSelling: {
    nOperation: 1123,
    type: "CROSS SELLING TIPO 1",
    agent: "ALEJANDRO CRISTO",
    total: "1.100 €",
  },
};

const cartsOr = [
  {
    id: 100,
    patientId: 1,
    patientCode: "40",
    patientNameLastName: "ALEJANDRO CRISTO GARCÍA",
    cardType: "montura",
    total: 829.2,
    lines: [
      {
        id: 10045,
        code: "00000001",
        description: "MONTURA RED STORM",
        pvp: 110.3,
        dto: 1,
        iva: 21,
        pvu: 109.2,
        uds: 1,
        total: 109.2,
        stock: 11,
      },
      {
        id: 10046,
        code: "000000011",
        description: "GAFAS RED STORM",
        pvp: 400,
        dto: 10,
        iva: 21,
        pvu: 360,
        uds: 2,
        total: 720,
        stock: 0,
      },
    ],
  },
  {
    id: 101,
    patientId: 2,
    patientCode: "41",
    patientNameLastName: "ALEXANDRE CHRIST COUPE",
    cardType: "sol",
    total: 829.2,
    lines: [
      {
        id: 10145,
        code: "00000001",
        description: "LENTILLAS BLANCAS ESTILO GOTH",
        pvp: 110.3,
        dto: 1,
        iva: 21,
        pvu: 109.2,
        uds: 1,
        total: 109.2,
        stock: 55,
      },
      {
        id: 10146,
        code: "00000011",
        description: "LENTILLAS FIESTA LAGARTO RR-JULK",
        pvp: 400,
        dto: 10,
        iva: 21,
        pvu: 360,
        uds: 2,
        total: 720,
        stock: 111,
      },
    ],
  },
];

/*export const paymentMethodsOr = [
  {
    id: "TARJETA",
    text: "TARJETA",
  },
  {
    id: "EN EFECTIVO",
    text: "EN EFECTIVO",
  },
];

export const paymentCardTypesOr = [
  {
    id: "",
    text: "",
  },
  {
    id: "VISA",
    text: "VISA",
  },
  {
    id: "MASTERCARD",
    text: "MASTERCARD",
  },
];

const cashVouchersOr = [
  {
    id: 1,
    text: "30 €",
    value: 30,
  },
  {
    id: 2,
    text: "2 €",
    value: 2,
  },
  {
    id: 3,
    text: "1.000 €",
    value: 1000,
  },
  {
    id: 4,
    text: "100 €",
    value: 100,
  },
];

*/
